'use strict';
/* ================================================================
   DRP Media — Customizer Editor v3
   Front/back views · Multi-element canvas · Text tool
   ================================================================ */
(function () {

  var cfg = window.DRP_CUSTOMIZER_EDITOR || {};
  var MIDDLEWARE_URL = cfg.middlewareUrl || 'https://drp-media-production.up.railway.app';

  /* ── Color map ──────────────────────────────────────────────── */
  var DRP_COLOR_MAP = {
    'black':'#111111','white':'#FFFFFF','off white':'#FAF9F6','natural':'#F5F0E8',
    'cream':'#FFFDD0','ivory':'#FFFFF0','ash':'#B2BEB5','silver':'#C0C0C0',
    'light steel':'#B0C4DE','grey':'#808080','gray':'#808080','charcoal':'#36454F',
    'dark heather':'#414141','heather':'#B7B7B7','heather grey':'#9E9E9E',
    'heather gray':'#9E9E9E','sport grey':'#9E9E9E','ice grey':'#C4C4C4',
    'slate':'#708090','smoke':'#848884','graphite heather':'#444444',
    'navy':'#001F3F','sport dark navy':'#0A1128','dark navy':'#0A1128',
    'midnight':'#191970','indigo':'#3F51B5','indigo blue':'#3F51B5',
    'royal':'#4169E1','royal blue':'#4169E1','sapphire':'#0F52BA',
    'carolina blue':'#56A0D3','sky':'#87CEEB','sky blue':'#87CEEB',
    'light blue':'#ADD8E6','baby blue':'#BFEFFF','columbia blue':'#9BCDFF',
    'powder blue':'#B0E0E6','tropical blue':'#00BFFF','cobalt':'#0047AB',
    'denim':'#1560BD','lagoon blue':'#4CA3C3','steel blue':'#4682B4',
    'antique denim':'#5B7E91','green':'#008000','forest green':'#228B22',
    'military green':'#4B5320','army green':'#4B5320','olive':'#808000',
    'olive green':'#6B8E23','kelly green':'#4CBB17','irish green':'#009A44',
    'turf green':'#2E8B57','hunter green':'#355E3B','emerald':'#50C878',
    'lime':'#32CD32','mint green':'#98FF98','sage':'#B2AC88','moss':'#8A9A5B',
    'pine':'#01796F','kiwi':'#8EE53F','seafoam':'#9FE2BF',
    'safety green':'#6FFF00','bright green':'#66FF00','fern':'#4F7942',
    'red':'#DC143C','dark red':'#8B0000','cardinal red':'#C41E3A',
    'cardinal':'#C41E3A','maroon':'#800000','antique cherry red':'#CD5C5C',
    'cherry red':'#DC143C','brick red':'#CB4154','sangria':'#92000A',
    'fire red':'#CE2939','true red':'#BF1932','athletic red':'#CC0000',
    'hot coral':'#FF4040','poppy red':'#FF1F1F','orange':'#FF6600',
    'burnt orange':'#CC5500','tennessee orange':'#FF8200','texas orange':'#BF5700',
    'rust':'#B7410E','pumpkin':'#FF7518','safety orange':'#FF6600',
    'paprika':'#8D2100','yellow':'#FFD700','gold':'#FFD700','daisy':'#FFD700',
    'corn':'#FBEC5D','maize':'#FBEC5D','lemon':'#FFF44F',
    'vintage gold':'#BFA46C','antique gold':'#B8860B','pink':'#FFC0CB',
    'light pink':'#FFB6C1','baby pink':'#F4C2C2','flamingo':'#FC8EAC',
    'hot pink':'#FF69B4','safety pink':'#FF69B4','neon pink':'#FF6EC7',
    'heliconia':'#E4007C','raspberry':'#C72553','rose':'#FF007F',
    'blush':'#DE5D83','pale pink':'#FADADD','purple':'#800080',
    'violet':'#8B00FF','orchid':'#DA70D6','lilac':'#C8A2C8',
    'lavender':'#E6E6FA','plum':'#8E4585','berry':'#8E4585',
    'grape':'#6F2DA8','boysenberry':'#873260','eggplant':'#614051',
    'mulberry':'#C54B8C','brown':'#8B4513','chocolate':'#7B3F00',
    'chestnut':'#954535','mocha':'#7B4F3A','caramel':'#C68642',
    'tan':'#D2B480','khaki':'#C3B091','sand':'#C2B280','stone':'#D1C0A8',
    'latte':'#C7A882','vintage':'#D4A76A','espresso':'#3C2415',
    'coral':'#FF7F50','teal':'#008080','turquoise':'#40E0D0',
    'cyan':'#00FFFF','aqua':'#00FFFF','mint':'#98FF98',
    'seafoam green':'#9FE2BF','wine':'#722F37','burgundy':'#800020',
    'mustard':'#FFDB58','antique':'#E9DECE','heather navy':'#3A4F6A',
    'heather blue':'#6B8DB8','heather red':'#B05070','heather maroon':'#815060',
    'heather purple':'#7B5F8A','heather green':'#5A7A5C',
  };

  function resolveSwatchColor(name) {
    var lower = (name || '').toLowerCase().trim();
    if (DRP_COLOR_MAP[lower]) return DRP_COLOR_MAP[lower];
    var words = lower.replace(/[^a-z ]/g, '').split(/\s+/);
    for (var i = words.length - 1; i >= 0; i--) {
      if (DRP_COLOR_MAP[words[i]]) return DRP_COLOR_MAP[words[i]];
    }
    return null;
  }

  function hexLuminance(hex) {
    var r = parseInt(hex.slice(1,3),16), g = parseInt(hex.slice(3,5),16), b = parseInt(hex.slice(5,7),16);
    return (0.299*r + 0.587*g + 0.114*b) / 255;
  }

  var METHOD_MIN_QTY = { 'Screen Printing':24, 'DTF':1, 'Embroidery':12, 'Vinyl':1 };

  var TEXT_FONTS = [
    { label:'Space Grotesk',    value:'Space Grotesk',   google:false },
    { label:'Arial',            value:'Arial',            google:false },
    { label:'Impact',           value:'Impact',           google:false },
    { label:'Georgia',          value:'Georgia',          google:false },
    { label:'Courier New',      value:'Courier New',      google:false },
    { label:'Bebas Neue',       value:'Bebas Neue',       google:true  },
    { label:'Montserrat',       value:'Montserrat',       google:true  },
    { label:'Oswald',           value:'Oswald',           google:true  },
    { label:'Permanent Marker', value:'Permanent Marker', google:true  },
    { label:'Lobster',          value:'Lobster',          google:true  },
  ];

  var TEXT_COLORS = [
    '#111111','#FFFFFF','#DC143C','#001F3F','#E8F60E',
    '#228B22','#FF6600','#FF69B4','#808080','#FFD700',
  ];

  /* ── Global state ───────────────────────────────────────────── */
  var S = {
    product:           null,
    colorOptionIdx:    -1,
    sizeOptionIdx:     -1,
    colorImageMap:     {},
    backImageMap:      {},
    variantData:       [],
    selectedColor:     '',
    selectedSize:      '',
    selectedVariantId: 0,
    garmentCents:      0,
    quantity:          1,
    method:            '',
    numColors:         1,
    location:          'Front',
    locationKey:       'front',
    printSize:         '',
    printSizeKey:      '',
    notes:             '',
    copyright:         false,
    uploading:         false,
    atcLoading:        false,
  };

  /* ── Design state (per-side element arrays) ─────────────────── */
  var DS = {
    front: { elements: [] },
    back:  { elements: [] },
  };
  var currentSide  = 'front';
  var selectedElId = null;

  function currentElements() { return DS[currentSide].elements; }

  function nextElId() {
    return 'el-' + Date.now() + '-' + Math.floor(Math.random() * 9999);
  }

  function selectedElement() {
    if (!selectedElId) return null;
    return currentElements().find(function (e) { return e.id === selectedElId; }) || null;
  }

  function hasAnyElement() {
    return DS.front.elements.length > 0 || DS.back.elements.length > 0;
  }

  /* ── Undo / Redo ─────────────────────────────────────────────── */
  var undoStack = [];
  var redoStack = [];
  var MAX_UNDO  = 30;

  function cloneDS() {
    var snap = { front: { elements: [] }, back: { elements: [] } };
    ['front', 'back'].forEach(function (side) {
      snap[side].elements = DS[side].elements.map(function (e) {
        var copy = {};
        for (var k in e) { if (k !== 'imgObj') copy[k] = e[k]; }
        return copy;
      });
    });
    return snap;
  }

  function saveState() {
    undoStack.push(cloneDS());
    if (undoStack.length > MAX_UNDO) undoStack.shift();
    redoStack.length = 0;
    updateUndoRedoUI();
  }

  function applySnapshot(snap) {
    ['front', 'back'].forEach(function (side) {
      var imgCache = {};
      DS[side].elements.forEach(function (e) { imgCache[e.id] = e.imgObj; });
      DS[side].elements = snap[side].elements.map(function (e) {
        e.imgObj    = imgCache[e.id] || null;
        e.imgLoaded = !!e.imgObj;
        if (e.type === 'image' && !e.imgObj) {
          var src = e.blobUrl || e.processedUrl || e.url;
          if (src) {
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () { e.imgObj = img; e.imgLoaded = true; Canvas.draw(); };
            img.src = src;
          }
        }
        return e;
      });
    });
    selectedElId = null;
    Canvas.draw();
    renderElementsList();
    renderTextPanel();
    renderImageEditPanel();
    updateAtcButton();
    updateUndoRedoUI();
  }

  function undo() {
    if (!undoStack.length) return;
    redoStack.push(cloneDS());
    applySnapshot(undoStack.pop());
  }

  function redo() {
    if (!redoStack.length) return;
    undoStack.push(cloneDS());
    applySnapshot(redoStack.pop());
  }

  function updateUndoRedoUI() {
    var ub = document.getElementById('cxe-undo-btn');
    var rb = document.getElementById('cxe-redo-btn');
    if (ub) ub.disabled = !undoStack.length;
    if (rb) rb.disabled = !redoStack.length;
  }

  /* Safety guides visible flag (toggled by button) */
  var showSafetyGuides = true;

  /* Active tool in the icon toolbar */
  var activeToolName = 'colors';

  function loadGoogleFont(fontName) {
    if (document.querySelector('link[data-font="' + fontName + '"]')) return;
    var link = document.createElement('link');
    link.rel  = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=' +
                encodeURIComponent(fontName).replace(/%20/g, '+') +
                ':wght@400;700&display=swap';
    link.dataset.font = fontName;
    document.head.appendChild(link);
  }

  /* ── Canvas module ──────────────────────────────────────────── */
  var Canvas = (function () {
    var el = null, ctx = null, stage = null;
    var baseSrcs    = { front: null, back: null };
    var baseImgs    = { front: null, back: null };
    var baseLoadeds = { front: false, back: false };
    var zoom = 1.0;
    var dragState   = null;
    var resizeState = null;
    var rotateState = null;
    var handles     = {};
    var SNAP        = 0.05;

    function fontStr(e) {
      return [(e.bold ? 'bold' : ''), (e.italic ? 'italic' : ''),
              Math.round(e.size * e.scale) + 'px',
              '"' + e.font + '",sans-serif'].filter(Boolean).join(' ');
    }

    function elBounds(e, W, H) {
      if (!W || !H) return null;
      if (e.type === 'image') {
        if (!e.imgLoaded || !e.imgObj) return null;
        var locKey = S.locationKey || 'front';
        var pos = (window.CUSTOMIZER_POSITIONS || {})[locKey] ||
                  { x: 0.25, y: 0.20, w: 0.50, h: 0.40 };
        var sm  = (window.CUSTOMIZER_SIZE_MULTIPLIERS || {})[S.printSizeKey] || 1.0;
        var bw  = pos.w * W * sm * e.scale;
        var bh  = (e.imgObj.height / e.imgObj.width) * bw;
        return { x: e.x * W - bw / 2, y: e.y * H - bh / 2, w: bw, h: bh };
      } else {
        if (!e.content) return null;
        ctx.save();
        ctx.font = fontStr(e);
        var tw = ctx.measureText(e.content).width;
        ctx.restore();
        var th = Math.round(e.size * e.scale) * 1.3;
        var ox = e.align === 'center' ? tw / 2 : e.align === 'right' ? tw : 0;
        return { x: e.x * W - ox, y: e.y * H - th / 2, w: tw, h: th };
      }
    }

    /* Local dimensions (w, h) for an element — rotation-independent */
    function elLocalDims(e, W, H) {
      if (e.type === 'image') {
        if (!e.imgLoaded || !e.imgObj) return null;
        var locKey = S.locationKey || 'front';
        var pos = (window.CUSTOMIZER_POSITIONS || {})[locKey] || { x:0.25, y:0.20, w:0.50, h:0.40 };
        var sm  = (window.CUSTOMIZER_SIZE_MULTIPLIERS || {})[S.printSizeKey] || 1.0;
        var bw  = pos.w * W * sm * e.scale;
        var bh  = (e.imgObj.height / e.imgObj.width) * bw;
        return { w: bw, h: bh };
      } else {
        if (!e.content) return null;
        ctx.save(); ctx.font = fontStr(e);
        var tw = ctx.measureText(e.content).width;
        ctx.restore();
        return { w: tw, h: Math.round(e.size * e.scale) * 1.3 };
      }
    }

    /* Rotation-aware hit test — inverse-transforms click into element local space */
    function hitTest(fx, fy) {
      var els = DS[currentSide].elements;
      for (var i = els.length - 1; i >= 0; i--) {
        var e  = els[i];
        var W  = el.width, H = el.height;
        var rot = (e.rotation || 0) * Math.PI / 180;
        var dx = fx * W - e.x * W, dy = fy * H - e.y * H;
        var cosR = Math.cos(-rot), sinR = Math.sin(-rot);
        var lx = cosR * dx - sinR * dy, ly = sinR * dx + cosR * dy;
        var dims = elLocalDims(e, W, H);
        if (!dims) continue;
        var pad = 10;
        if (lx >= -dims.w/2 - pad && lx <= dims.w/2 + pad &&
            ly >= -dims.h/2 - pad && ly <= dims.h/2 + pad) return e;
      }
      return null;
    }

    /* Draw one element — translates to center then rotates */
    function drawEl(e) {
      if (!e || !el) return;
      var W = el.width, H = el.height;
      var cx = e.x * W, cy = e.y * H;
      var rot = (e.rotation || 0) * Math.PI / 180;
      ctx.save();
      ctx.translate(cx, cy);
      if (rot) ctx.rotate(rot);
      if (e.type === 'image') {
        if (!e.imgLoaded || !e.imgObj) { ctx.restore(); return; }
        var dims = elLocalDims(e, W, H);
        if (!dims) { ctx.restore(); return; }
        ctx.globalAlpha = 0.88;
        /* Use processedUrl-backed image if bg removal is active */
        ctx.drawImage(e.imgObj, -dims.w/2, -dims.h/2, dims.w, dims.h);
      } else {
        if (!e.content) { ctx.restore(); return; }
        ctx.font = fontStr(e);
        ctx.fillStyle = e.color || '#FFFFFF';
        ctx.textAlign = e.align || 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(e.content, 0, 0);
      }
      ctx.restore();
    }

    /* Update corner handles + rotation handle to match selected element (rotation-aware) */
    function updateHandles(e) {
      var allHandleKeys = ['tl','tr','bl','br','rot'];
      if (!e || !el) {
        allHandleKeys.forEach(function(k) { var h = handles[k]; if (h) h.style.display = 'none'; });
        return;
      }
      var W = el.width, H = el.height;
      var dims = elLocalDims(e, W, H);
      if (!dims) {
        allHandleKeys.forEach(function(k) { var h = handles[k]; if (h) h.style.display = 'none'; });
        return;
      }
      var rot  = (e.rotation || 0) * Math.PI / 180;
      var cosR = Math.cos(rot), sinR = Math.sin(rot);
      var sx   = (stage.clientWidth  || W) / W;
      var sy   = (stage.clientHeight || H) / H;
      var hw   = dims.w / 2, hh = dims.h / 2;
      function screenPt(lx, ly) {
        return {
          x: (e.x * W + cosR * lx - sinR * ly) * sx,
          y: (e.y * H + sinR * lx + cosR * ly) * sy,
        };
      }
      var corners = {
        tl: screenPt(-hw, -hh), tr: screenPt(hw, -hh),
        bl: screenPt(-hw,  hh), br: screenPt(hw,  hh),
      };
      ['tl','tr','bl','br'].forEach(function(k) {
        var h = handles[k]; if (!h) return;
        h.style.display = 'block';
        h.style.left = corners[k].x + 'px';
        h.style.top  = corners[k].y + 'px';
      });
      var rotH = handles.rot;
      if (rotH) {
        var rp = screenPt(0, -hh - 28 / sy);
        rotH.style.display = 'block';
        rotH.style.left = rp.x + 'px';
        rotH.style.top  = rp.y + 'px';
      }
    }

    /* Safety area overlay */
    function drawSafetyArea(W, H) {
      if (!showSafetyGuides) return;
      var locKey = S.locationKey || 'front';
      var pos = (window.CUSTOMIZER_POSITIONS || {})[locKey];
      if (!pos) return;
      ctx.save();
      ctx.strokeStyle = 'rgba(232,246,14,0.35)';
      ctx.lineWidth = 1;
      ctx.setLineDash([6, 4]);
      ctx.strokeRect(pos.x * W, pos.y * H, pos.w * W, pos.h * H);
      ctx.fillStyle = 'rgba(232,246,14,0.45)';
      ctx.font = '10px "Space Grotesk",sans-serif';
      ctx.textAlign = 'left';
      ctx.textBaseline = 'bottom';
      ctx.fillText('Safe Area', pos.x * W + 4, pos.y * H - 3);
      ctx.restore();
    }

    function draw(showGuides) {
      if (!el || !ctx) return;
      var W = el.width, H = el.height;
      ctx.clearRect(0, 0, W, H);

      /* Base product image */
      var bImg = baseImgs[currentSide];
      if (bImg && baseLoadeds[currentSide]) {
        ctx.save();
        if (zoom !== 1.0) {
          ctx.translate(W/2, H/2); ctx.scale(zoom, zoom); ctx.translate(-W/2, -H/2);
        }
        ctx.drawImage(bImg, 0, 0, W, H);
        ctx.restore();
      } else {
        ctx.fillStyle = '#1A1A1A';
        ctx.fillRect(0, 0, W, H);
        if (currentSide === 'back' && !baseLoadeds.back) {
          ctx.fillStyle = '#555';
          ctx.font = '13px "Space Grotesk",sans-serif';
          ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText('Back view (approximate)', W / 2, H / 2);
        }
      }

      /* Safety area guides (drawn before elements so they're below artwork) */
      drawSafetyArea(W, H);

      /* Elements */
      var els = DS[currentSide].elements;
      for (var i = 0; i < els.length; i++) {
        drawEl(els[i]);
        if (els[i].id === selectedElId) {
          var dims = elLocalDims(els[i], W, H);
          if (dims) {
            var rot = (els[i].rotation || 0) * Math.PI / 180;
            ctx.save();
            ctx.translate(els[i].x * W, els[i].y * H);
            if (rot) ctx.rotate(rot);
            ctx.strokeStyle = 'rgba(232,246,14,0.7)';
            ctx.lineWidth = 1.5; ctx.setLineDash([5, 3]);
            ctx.strokeRect(-dims.w/2 - 2, -dims.h/2 - 2, dims.w + 4, dims.h + 4);
            /* Line to rotation handle */
            ctx.strokeStyle = 'rgba(232,246,14,0.5)';
            ctx.lineWidth = 1; ctx.setLineDash([3, 3]);
            ctx.beginPath(); ctx.moveTo(0, -dims.h/2 - 2); ctx.lineTo(0, -dims.h/2 - 26); ctx.stroke();
            ctx.restore();
          }
        }
      }
      updateHandles(selectedElement());

      /* Out-of-bounds warning when element is dragged outside safe area */
      if (dragState) {
        var elem = currentElements().find(function(x) { return x.id === dragState.elId; });
        if (elem) {
          var locKey = S.locationKey || 'front';
          var pos = (window.CUSTOMIZER_POSITIONS || {})[locKey];
          if (pos && (elem.x < pos.x || elem.x > pos.x + pos.w || elem.y < pos.y || elem.y > pos.y + pos.h)) {
            ctx.save();
            ctx.fillStyle = 'rgba(245,158,11,0.85)';
            ctx.font = '11px "Space Grotesk",sans-serif';
            ctx.textAlign = 'center'; ctx.textBaseline = 'top';
            ctx.fillText('Outside printable area', W / 2, 6);
            ctx.restore();
          }
        }
      }

      /* Alignment crosshairs while dragging */
      if (showGuides && dragState) {
        ctx.save();
        ctx.strokeStyle = 'rgba(232,246,14,0.55)';
        ctx.lineWidth = 1; ctx.setLineDash([4, 4]);
        ctx.beginPath(); ctx.moveTo(W/2, 0); ctx.lineTo(W/2, H); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(0, H/2); ctx.lineTo(W, H/2); ctx.stroke();
        ctx.restore();
      }
    }

    function loadBaseForSide(side) {
      var src = baseSrcs[side];
      if (!src) return;
      baseLoadeds[side] = false;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        baseImgs[side] = img; baseLoadeds[side] = true;
        console.log('[cxe] base img loaded (' + side + '):', src.slice(0, 80));
        if (side === currentSide) draw();
      };
      img.onerror = function () { console.warn('[cxe] base img error (' + side + '):', src); };
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      img.src = src + sep + '_c=1';
    }

    function eventFrac(e) {
      var rect = el.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      var cy = e.touches ? e.touches[0].clientY : e.clientY;
      return { x: (cx - rect.left) / rect.width, y: (cy - rect.top) / rect.height };
    }

    function snap(v, t) { return Math.abs(v - t) < SNAP ? t : v; }

    function onDown(e) {
      var f   = eventFrac(e);
      var hit = hitTest(f.x, f.y);
      if (hit) {
        selectedElId = hit.id;
        dragState = { elId: hit.id, offX: f.x - hit.x, offY: f.y - hit.y };
        el.style.cursor = 'grabbing';
        e.preventDefault();
      } else {
        selectedElId = null;
        dragState    = null;
        updateHandles(null);
      }
      draw();
      renderElementsList();
      renderTextPanel();
    }

    function onMove(e) {
      if (dragState) {
        e.preventDefault();
        var f    = eventFrac(e);
        var elem = currentElements().find(function (x) { return x.id === dragState.elId; });
        if (elem) {
          elem.x = snap(Math.max(0.02, Math.min(0.98, f.x - dragState.offX)), 0.5);
          elem.y = snap(Math.max(0.02, Math.min(0.98, f.y - dragState.offY)), 0.5);
          draw(true);
        }
      } else {
        el.style.cursor = hitTest(eventFrac(e).x, eventFrac(e).y) ? 'grab' : 'default';
      }
    }

    function onUp() {
      if (dragState) {
        dragState = null;
        el.style.cursor = 'grab';
        draw(false);
        saveState();
      }
    }

    function onResizeDown(k, e) {
      if (!selectedElId) return;
      var elem = selectedElement();
      if (!elem) return;
      var sr = stage.getBoundingClientRect();
      var mx = e.touches ? e.touches[0].clientX : e.clientX;
      var my = e.touches ? e.touches[0].clientY : e.clientY;
      resizeState = {
        elId: elem.id, startScale: elem.scale,
        cx: sr.left + elem.x * stage.clientWidth,
        cy: sr.top  + elem.y * stage.clientHeight,
        startDist: Math.sqrt(Math.pow(mx - (sr.left + elem.x * stage.clientWidth), 2) +
                             Math.pow(my - (sr.top  + elem.y * stage.clientHeight), 2)),
      };
      e.preventDefault(); e.stopPropagation();
    }

    function onResizeMove(e) {
      if (!resizeState || resizeState.startDist === 0) return;
      e.preventDefault();
      var mx = e.touches ? e.touches[0].clientX : e.clientX;
      var my = e.touches ? e.touches[0].clientY : e.clientY;
      var dist = Math.sqrt(Math.pow(mx - resizeState.cx, 2) + Math.pow(my - resizeState.cy, 2));
      var elem = currentElements().find(function (x) { return x.id === resizeState.elId; });
      if (elem) {
        elem.scale = Math.max(0.1, Math.min(4.0, resizeState.startScale * (dist / resizeState.startDist)));
        draw(false);
      }
    }

    function onResizeUp() {
      if (resizeState) { resizeState = null; saveState(); }
    }

    /* ── Rotation handlers ─────────────────────────────────── */
    function onRotateDown(e) {
      var elem = selectedElement();
      if (!elem) return;
      var sr  = stage.getBoundingClientRect();
      var mx  = e.touches ? e.touches[0].clientX : e.clientX;
      var my  = e.touches ? e.touches[0].clientY : e.clientY;
      var cx  = sr.left + elem.x * stage.clientWidth;
      var cy  = sr.top  + elem.y * stage.clientHeight;
      rotateState = {
        elId: elem.id,
        startRotation: elem.rotation || 0,
        startAngle: Math.atan2(my - cy, mx - cx) * 180 / Math.PI,
        cx: cx, cy: cy,
      };
      e.preventDefault(); e.stopPropagation();
    }

    function onRotateMove(e) {
      if (!rotateState) return;
      e.preventDefault();
      var mx = e.touches ? e.touches[0].clientX : e.clientX;
      var my = e.touches ? e.touches[0].clientY : e.clientY;
      var angle  = Math.atan2(my - rotateState.cy, mx - rotateState.cx) * 180 / Math.PI;
      var newRot = ((rotateState.startRotation + angle - rotateState.startAngle) % 360 + 360) % 360;
      /* Snap to 0 / 90 / 180 / 270 within ±5° */
      [0, 90, 180, 270, 360].forEach(function (s) {
        if (Math.abs(newRot - s) < 5) newRot = s % 360;
      });
      var elem = currentElements().find(function (x) { return x.id === rotateState.elId; });
      if (elem) { elem.rotation = newRot; draw(false); }
    }

    function onRotateUp() {
      if (rotateState) {
        rotateState = null;
        saveState();
        /* Refresh rotation input in panel */
        renderTextPanel(); renderImageEditPanel();
      }
    }

    return {
      init: function (canvasEl, stageEl) {
        el = canvasEl; stage = stageEl;
        ctx = canvasEl.getContext('2d');
        window.requestAnimationFrame(function () {
          el.width  = stage.clientWidth  || 400;
          el.height = stage.clientHeight || 400;
          console.log('[cxe] canvas:', el.width, 'x', el.height);
          draw();
        });
        handles = {
          tl: document.getElementById('cxe-handle-tl'),
          tr: document.getElementById('cxe-handle-tr'),
          bl: document.getElementById('cxe-handle-bl'),
          br: document.getElementById('cxe-handle-br'),
          rot: document.getElementById('cxe-handle-rot'),
        };
        el.addEventListener('mousedown',  onDown,  { passive: false });
        el.addEventListener('mousemove',  onMove,  { passive: false });
        el.addEventListener('mouseup',    onUp);
        el.addEventListener('mouseleave', onUp);
        el.addEventListener('touchstart', onDown,  { passive: false });
        el.addEventListener('touchmove',  onMove,  { passive: false });
        el.addEventListener('touchend',   onUp);
        ['tl','tr','bl','br'].forEach(function (k) {
          var h = handles[k]; if (!h) return;
          h.addEventListener('mousedown',  function (e) { onResizeDown(k, e); });
          h.addEventListener('touchstart', function (e) { onResizeDown(k, e); }, { passive: false });
        });
        if (handles.rot) {
          handles.rot.addEventListener('mousedown',  onRotateDown);
          handles.rot.addEventListener('touchstart', onRotateDown, { passive: false });
        }
        document.addEventListener('mousemove', onResizeMove, { passive: false });
        document.addEventListener('mouseup',   onResizeUp);
        document.addEventListener('touchmove', onResizeMove, { passive: false });
        document.addEventListener('touchend',  onResizeUp);
        document.addEventListener('mousemove', onRotateMove, { passive: false });
        document.addEventListener('mouseup',   onRotateUp);
        document.addEventListener('touchmove', onRotateMove, { passive: false });
        document.addEventListener('touchend',  onRotateUp);
      },

      setBase: function (side, src) { baseSrcs[side] = src; loadBaseForSide(side); },

      switchSide: function (side) {
        currentSide = side; selectedElId = null; updateHandles(null); draw();
        renderElementsList(); renderTextPanel(); renderImageEditPanel();
      },

      addElement: function (elData) {
        saveState();
        DS[currentSide].elements.push(elData);
        selectedElId = elData.id;
        draw(); renderElementsList(); renderTextPanel(); renderImageEditPanel(); updateAtcButton();
      },

      removeElement: function (id) {
        saveState();
        DS[currentSide].elements = DS[currentSide].elements.filter(function (e) { return e.id !== id; });
        if (selectedElId === id) { selectedElId = null; updateHandles(null); }
        draw(); renderElementsList(); renderTextPanel(); renderImageEditPanel(); updateAtcButton();
      },

      selectElement: function (id) {
        selectedElId = id; draw(); renderElementsList(); renderTextPanel(); renderImageEditPanel();
      },

      setLocation: function (locKey) {
        var elem = selectedElement();
        if (elem) {
          var pos = (window.CUSTOMIZER_POSITIONS || {})[locKey] || { x:0.25, y:0.20, w:0.50, h:0.40 };
          elem.x = pos.x + pos.w / 2;
          elem.y = pos.y + pos.h / 2;
          draw();
        }
      },

      resetPosition: function () {
        var elem = selectedElement();
        if (elem) {
          var pos = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25, y:0.20, w:0.50, h:0.40 };
          elem.x = pos.x + pos.w / 2;
          elem.y = pos.y + pos.h / 2;
          draw();
        }
      },

      zoomIn:  function () { zoom = Math.min(2.0, zoom + 0.1); draw(); },
      zoomOut: function () { zoom = Math.max(0.5, zoom - 0.1); draw(); },
      draw:    draw,

      captureCurrentSide: function () {
        try { return el.toDataURL('image/png'); }
        catch (e) { console.warn('[cxe] capture CORS:', e.message); return null; }
      },

      captureSide: function (side) {
        if (side === currentSide) return this.captureCurrentSide();
        var prev = currentSide, prevSel = selectedElId;
        currentSide = side; selectedElId = null; updateHandles(null);
        draw(false);
        var dataUrl = this.captureCurrentSide();
        currentSide = prev; selectedElId = prevSel;
        draw(false);
        return dataUrl;
      },
    };
  })();

  /* ── Helpers ────────────────────────────────────────────────── */
  function fmt(cents) {
    if (window.CustPricing) return window.CustPricing.fmt(cents);
    return 'CA$' + (cents / 100).toFixed(2);
  }

  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function getVariantOption(v, idx) {
    if (Array.isArray(v.options) && idx < v.options.length) {
      var val = v.options[idx];
      return val != null ? String(val) : null;
    }
    var key = ['option1','option2','option3'][idx];
    var fb  = key ? v[key] : undefined;
    return fb != null ? String(fb) : null;
  }

  /* ── Static DOM refs ────────────────────────────────────────── */
  var wrapEl        = document.getElementById('cxe-wrap');
  var notFoundEl    = document.getElementById('cxe-not-found');
  var leftEl        = document.getElementById('cxe-left');
  var breakdownEl   = document.getElementById('cxe-pricing-breakdown');
  var atcBtn        = document.getElementById('cxe-atc-btn');
  var mobileAtcBtn  = document.getElementById('cxe-mobile-atc-btn');
  var mobileTotalEl = document.getElementById('cxe-mobile-total');
  var atcErrEl      = document.getElementById('cxe-atc-err');
  var copyrightCk   = document.getElementById('cxe-copyright-check');
  var copyrightErrEl= document.getElementById('cxe-copyright-err');
  var notesEl       = document.getElementById('cxe-notes');
  var notesCountEl  = document.getElementById('cxe-notes-count');
  var designersMsgEl= document.getElementById('cxe-designers-msg');
  var backLinkEl    = document.getElementById('cxe-back-link');
  var titleEl       = document.getElementById('cxe-product-title');
  var canvasEl      = document.getElementById('cxe-canvas');
  var stageEl       = document.getElementById('cxe-canvas-stage');
  var resetBtn      = document.getElementById('cxe-reset-btn');
  var zoomInBtn     = document.getElementById('cxe-zoom-in');
  var zoomOutBtn    = document.getElementById('cxe-zoom-out');
  var viewToggleEl  = document.getElementById('cxe-view-toggle');

  /* ── Pricing / ATC button ───────────────────────────────────── */
  function updatePricing() {
    if (!window.CustPricing) return 0;
    var total = window.CustPricing.getCustomizedPrice(
      S.garmentCents, S.method, S.printSizeKey, S.quantity, S.numColors
    );
    window.CustPricing.renderBreakdown(breakdownEl, S.garmentCents, true, {
      method: S.method, sizeKey: S.printSizeKey, printSize: S.printSize,
      qty: S.quantity, numColors: S.numColors,
    });
    if (mobileTotalEl) mobileTotalEl.textContent = S.method ? fmt(total) : '—';
    return total;
  }

  function updateAtcButton() {
    if (S.atcLoading) return;
    var disabled = false, reason = '';
    if (!S.selectedColor)            { disabled = true; reason = 'Select a color'; }
    else if (!S.selectedVariantId)   { disabled = true; reason = 'Select a size'; }
    else if (!S.method)              { disabled = true; reason = 'Choose a print method'; }
    else if (!S.location)            { disabled = true; reason = 'Choose print location'; }
    else if (!S.printSize)           { disabled = true; reason = 'Choose print size'; }
    else if (!hasAnyElement() && !NN.active) { disabled = true; reason = 'Add artwork or text'; }
    else if (NN.active && !NN.rows.length)  { disabled = true; reason = 'Add at least one person'; }
    else if (NN.active && NN.rows.some(function(r) { return !r.name; })) { disabled = true; reason = 'Name is required for each row'; }
    else if (NN.active && NN.rows.some(function(r) { return !r.size; })) { disabled = true; reason = 'Size is required for each row'; }
    else if (!S.copyright)           { disabled = true; reason = 'Accept copyright terms'; }
    else if (S.uploading)            { disabled = true; reason = 'Uploading…'; }
    else if (S.method === 'Vinyl' && S.numColors > 4) { disabled = true; reason = 'Max 4 colors for vinyl'; }
    else if (S.method && S.quantity < (METHOD_MIN_QTY[S.method] || 1)) {
      disabled = true; reason = 'Min. ' + METHOD_MIN_QTY[S.method] + ' units for ' + S.method;
    }
    var total = updatePricing();
    renderNNSummary();
    var label;
    if (disabled) {
      label = reason;
    } else if (NN.active && NN.rows.length > 0) {
      var sf  = window.CustPricing ? window.CustPricing.getSetupFee(S.method) : 0;
      var cf  = window.CustPricing ? window.CustPricing.getColorFee(S.method, S.numColors) : 0;
      var pfu = window.CustPricing ? window.CustPricing.getPrintFeePerUnit(S.method, S.printSizeKey) : 0;
      var bulkTotal = (S.garmentCents + pfu) * NN.rows.length + sf + cf;
      label = 'ADD TO CART — ' + NN.rows.length + ' ' + (NN.rows.length === 1 ? 'shirt' : 'shirts') + (bulkTotal ? ' — ' + fmt(bulkTotal) : '');
    } else {
      label = 'ADD TO CART' + (total ? ' — ' + fmt(total) : '');
    }
    [atcBtn, mobileAtcBtn].forEach(function (b) {
      if (!b) return; b.disabled = disabled; b.textContent = label;
    });
  }

  /* ── Side switcher ──────────────────────────────────────────── */
  function selectSide(side) {
    currentSide = side;
    Canvas.switchSide(side);

    /* Update view toggle UI */
    document.querySelectorAll('.cxe-view-card').forEach(function (card) {
      card.classList.toggle('is-active', card.dataset.side === side);
    });

    /* Update designer's message (if applicable for current side) */
    var isDesigner = S.locationKey === 'designers_choice';
    if (designersMsgEl) designersMsgEl.hidden = !isDesigner;

    renderElementsList();
  }

  /* ── Left rail — section builders ──────────────────────────── */
  function methodRecText(qty) {
    if (qty <= 1)  return 'Recommended: Vinyl or Embroidery — best for single items.';
    if (qty <= 11) return 'Recommended: Vinyl, Embroidery, or DTF — ideal for small runs.';
    if (qty <= 23) return 'Recommended: DTF — best value for medium runs.';
    return 'Best value: Screen Printing — lowest per-unit cost at high volume.';
  }

  function renderColorGallery(colorName) {
    var galleryEl = document.getElementById('cxe-color-gallery');
    if (!galleryEl) return;
    var urls = [];
    var front = S.colorImageMap[colorName];
    var back  = S.backImageMap[colorName];
    if (front) urls.push({ url: front, side: 'front' });
    if (back)  urls.push({ url: back,  side: 'back'  });
    if (!urls.length) { galleryEl.style.display = 'none'; return; }
    galleryEl.style.display = '';
    galleryEl.innerHTML = urls.map(function (item) {
      var active = item.side === currentSide ? ' is-active' : '';
      return '<button type="button" class="cxe-color-thumb' + active + '" data-side="' + item.side +
             '" style="background-image:url(' + item.url + ')" aria-label="' + item.side + ' view"></button>';
    }).join('');
    galleryEl.querySelectorAll('.cxe-color-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSide(btn.dataset.side);
        galleryEl.querySelectorAll('.cxe-color-thumb').forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.side === btn.dataset.side);
        });
      });
    });
  }

  function buildColorSection(colorValues) {
    var html = '<div class="cxe-panel" id="cxe-color-section">';
    html += '<h3 class="cxe-section-label">Color</h3>';
    html += '<div class="cxe-color-gallery" id="cxe-color-gallery" style="display:none"></div>';
    html += '<div class="cxe-swatches" id="cxe-swatches">';
    colorValues.forEach(function (rawName) {
      var name = rawName != null ? String(rawName) : '';
      var hex  = resolveSwatchColor(name);
      var innerStyle;
      if (hex) {
        var lum = hexLuminance(hex);
        var shadow = lum > 0.82
          ? 'box-shadow:inset 0 0 0 1px rgba(0,0,0,0.25);'
          : lum < 0.25
            ? 'box-shadow:inset 0 0 0 1.5px rgba(255,255,255,0.25);'
            : '';
        innerStyle = 'background:' + hex + ';' + shadow;
      } else {
        innerStyle = 'background:linear-gradient(135deg,#3a3a3a,#555);color:#f0f0f0;font-size:7px;font-weight:700;';
      }
      var initials = hex ? '' : name.split(/\s+/).map(function (w) { return w[0]||''; }).join('').toUpperCase().slice(0, 3);
      html += '<button type="button" class="cxe-swatch" data-color="' + escHtml(name) +
              '" title="' + escHtml(name) + '" aria-label="' + escHtml(name) + '">' +
              '<span class="cxe-swatch__inner" style="' + innerStyle + '">' + escHtml(initials) + '</span></button>';
    });
    html += '</div>';
    html += '<div class="cxe-swatch-selected-name" id="cxe-swatch-name"></div>';
    html += '</div>';
    return html;
  }

  function buildSizeSection() {
    return '<div class="cxe-panel" id="cxe-size-section">' +
           '<h3 class="cxe-section-label">Size</h3>' +
           '<div class="cxe-sizes" id="cxe-sizes"></div></div>';
  }

  function rebuildSizes(colorName) {
    var sizesEl = document.getElementById('cxe-sizes');
    if (!sizesEl) return;
    var variants = S.variantData.slice();
    if (S.colorOptionIdx >= 0 && colorName) {
      variants = variants.filter(function (v) {
        return getVariantOption(v, S.colorOptionIdx) === colorName;
      });
    }
    if (window.DRPSizeSort && S.sizeOptionIdx >= 0) {
      window.DRPSizeSort.sortBy(variants, function (v) {
        return getVariantOption(v, S.sizeOptionIdx) || '';
      });
    }
    sizesEl.innerHTML = '';
    variants.forEach(function (v) {
      var size  = S.sizeOptionIdx >= 0 ? (getVariantOption(v, S.sizeOptionIdx) || '?') : '?';
      var stock = v.inventory_quantity;
      var stockHtml = !v.available
        ? '<span class="cxe-size-btn__stock" style="color:#6B6B6B">Out</span>'
        : (stock > 0 && stock <= 10 ? '<span class="cxe-size-btn__stock" style="color:#E8F60E">' + stock + ' left</span>' : '');
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'cxe-size-btn';
      btn.dataset.variantId = String(v.id); btn.dataset.size = size;
      btn.disabled = !v.available;
      btn.innerHTML = escHtml(size) + stockHtml;
      btn.addEventListener('click', function () { selectSize(size, v.id, v.price); });
      sizesEl.appendChild(btn);
    });
  }

  function buildQtySection() {
    return '<div class="cxe-panel" id="cxe-qty-section"><h3 class="cxe-section-label">Quantity</h3>' +
           '<div class="cxe-qty-group">' +
           '<button type="button" class="cxe-qty-btn" id="cxe-qty-minus" aria-label="Decrease">−</button>' +
           '<input type="number" id="cxe-qty-input" class="cxe-qty-input" value="1" min="1" aria-label="Quantity">' +
           '<button type="button" class="cxe-qty-btn" id="cxe-qty-plus" aria-label="Increase">+</button>' +
           '</div></div>';
  }

  function buildMethodSection() {
    var methods = [
      { name:'Screen Printing', desc:'Best for bulk (24+ units)',    fee:'$45 setup',      minQty:24 },
      { name:'Embroidery',      desc:'Best for logos & premium',     fee:'$30 digitizing', minQty:12 },
      { name:'Vinyl',           desc:'Best for names & small runs',  fee:'$10 prep',       minQty:1  },
      { name:'DTF',             desc:'Full-color medium runs',       fee:'No setup',       minQty:1  },
    ];
    var html = '<div class="cxe-panel" id="cxe-method-section">';
    html += '<h3 class="cxe-section-label">Print Method</h3>';
    html += '<div class="cxe-method-rec" id="cxe-method-rec" style="display:none"></div>';
    html += '<div class="cxe-method-grid">';
    methods.forEach(function (m) {
      html += '<button type="button" class="cxe-method-card" data-method="' + escHtml(m.name) + '" data-min-qty="' + m.minQty + '">' +
              '<div class="cxe-method-card__name">' + escHtml(m.name) + '</div>' +
              '<div class="cxe-method-card__desc">' + escHtml(m.desc) + '</div>' +
              '<div class="cxe-method-card__fee">' + escHtml(m.fee) + '</div></button>';
    });
    html += '</div><p class="cxe-method-warning" id="cxe-method-warning" style="display:none"></p></div>';
    return html;
  }

  function buildColorsSection() {
    return '<div class="cxe-panel" id="cxe-colors-section" style="display:none">' +
           '<h3 class="cxe-section-label">Number of Colors</h3>' +
           '<div class="cxe-colors-row"><div class="cxe-colors-stepper">' +
           '<button type="button" class="cxe-colors-btn" id="cxe-colors-minus">−</button>' +
           '<span class="cxe-colors-val" id="cxe-colors-val">1</span>' +
           '<button type="button" class="cxe-colors-btn" id="cxe-colors-plus">+</button>' +
           '</div></div><p class="cxe-colors-hint" id="cxe-colors-hint"></p></div>';
  }

  function buildLocationSection() {
    var locs = [
      { label:'Front',     key:'front',            icon:'👕' },
      { label:'Back',      key:'back',              icon:'🔙' },
      { label:'L. Chest',  key:'left_chest',        icon:'◀'  },
      { label:'R. Chest',  key:'right_chest',       icon:'▶'  },
      { label:'L. Sleeve', key:'left_sleeve',       icon:'◁'  },
      { label:'R. Sleeve', key:'right_sleeve',      icon:'▷'  },
      { label:'Designer',  key:'designers_choice',  icon:'✦'  },
    ];
    var html = '<div class="cxe-panel" id="cxe-location-section">' +
               '<h3 class="cxe-section-label">Print Location</h3>' +
               '<div class="cxe-location-grid">';
    locs.forEach(function (l) {
      html += '<button type="button" class="cxe-loc-card" data-location="' + escHtml(l.label) + '" data-key="' + l.key + '">' +
              '<span class="cxe-loc-card__icon">' + l.icon + '</span>' +
              '<span class="cxe-loc-card__label">' + escHtml(l.label) + '</span></button>';
    });
    return html + '</div></div>';
  }

  function buildPrintSizeSection() {
    var sizes = [
      { label:'Small',  dims:'4 × 4 inches',   key:'small',  w:16, h:16 },
      { label:'Medium', dims:'8 × 8 inches',   key:'medium', w:24, h:24 },
      { label:'Large',  dims:'12 × 12 inches', key:'large',  w:32, h:32 },
      { label:'Full',   dims:'Full coverage',  key:'full',   w:44, h:44 },
    ];
    var html = '<div class="cxe-panel" id="cxe-psize-section"><h3 class="cxe-section-label">Print Size</h3>' +
               '<div class="cxe-print-sizes">';
    sizes.forEach(function (s) {
      html += '<button type="button" class="cxe-psize-btn" data-size="' + escHtml(s.label + ' (' + s.dims.split(' ')[0] + '"' + ')') + '" data-key="' + s.key + '">' +
              '<span class="cxe-psize-preview" style="width:' + s.w + 'px;height:' + s.h + 'px"></span>' +
              '<span class="cxe-psize-label">' + escHtml(s.label) + '<br><span class="cxe-psize-dims">' + escHtml(s.dims) + '</span></span>' +
              '</button>';
    });
    return html + '</div></div>';
  }

  function buildUploadSection() {
    return '<div class="cxe-panel" id="cxe-upload-section">' +
           '<h3 class="cxe-section-label">Upload Artwork</h3>' +
           '<div class="cxe-upload-zone" id="cxe-upload-zone" role="button" tabindex="0" aria-label="Upload artwork">' +
           '<div class="cxe-upload-idle" id="cxe-upload-idle">' +
           '<svg class="cxe-upload-icon" width="36" height="36" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
           '<path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
           '<polyline points="17 8 12 3 7 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
           '<line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
           '</svg>' +
           '<strong>Drop your artwork here</strong>' +
           '<small>or click to browse · PDF, JPG, PNG, SVG · Max 25 MB</small></div>' +
           '<div class="cxe-upload-progress" id="cxe-upload-progress" style="display:none">' +
           '<div class="cxe-progress-bar"><div class="cxe-progress-bar__fill"></div></div></div>' +
           '</div>' +
           '<p class="cxe-file-error" id="cxe-file-error" style="display:none"></p>' +
           '<p class="cxe-res-warning" id="cxe-res-warning" style="display:none">⚠ Resolution may be low for crisp print.</p>' +
           '<input type="file" id="cxe-file-input" accept=".pdf,.jpg,.jpeg,.png,.svg" style="display:none">' +
           '</div>';
  }

  function buildTextSection() {
    return '<div class="cxe-panel" id="cxe-text-section">' +
           '<h3 class="cxe-section-label">Add Text</h3>' +
           '<button type="button" class="cxe-add-text-btn" id="cxe-add-text-btn">+ Add Text</button>' +
           '</div>';
  }

  function buildElementsList() {
    return '<div class="cxe-panel" id="cxe-el-list-section">' +
           '<h3 class="cxe-section-label" id="cxe-el-list-label">Design Elements</h3>' +
           '<div id="cxe-el-list"></div>' +
           '</div>';
  }

  /* ── Dynamic renderers (called after buildLeftRail exists) ─── */
  function renderElementsList() {
    var listEl  = document.getElementById('cxe-el-list');
    var labelEl = document.getElementById('cxe-el-list-label');
    if (!listEl) return;
    var els = DS[currentSide].elements;
    if (labelEl) labelEl.textContent = 'Design Elements (' + (currentSide === 'front' ? 'Front' : 'Back') + ')';
    if (els.length === 0) {
      listEl.innerHTML = '<p style="color:#6B6B6B;font-size:.8125rem;margin:0">No elements yet.</p>';
      return;
    }
    listEl.innerHTML = '';
    els.forEach(function (e) {
      var row = document.createElement('div');
      row.className = 'cxe-el-row' + (e.id === selectedElId ? ' is-selected' : '');
      var icon = e.type === 'image' ? '🖼' : 'T';
      var label = e.type === 'image'
        ? (e.filename || 'Image').slice(0, 22)
        : ('"' + (e.content || '').slice(0, 18) + (e.content && e.content.length > 18 ? '…' : '') + '"');
      row.innerHTML =
        '<span class="cxe-el-row__icon">' + icon + '</span>' +
        '<span class="cxe-el-row__label">' + escHtml(label) + '</span>' +
        '<button type="button" class="cxe-el-row__del" data-el-id="' + escHtml(e.id) + '" aria-label="Delete">✕</button>';
      row.addEventListener('click', function (ev) {
        if (ev.target.closest('.cxe-el-row__del')) return;
        Canvas.selectElement(e.id);
      });
      row.querySelector('.cxe-el-row__del').addEventListener('click', function (ev) {
        ev.stopPropagation();
        Canvas.removeElement(e.id);
      });
      listEl.appendChild(row);
    });
  }

  function renderTextPanel() {
    var panelEl = document.getElementById('cxe-text-edit-panel');
    if (!panelEl) return;
    var elem = selectedElement();
    if (!elem || elem.type !== 'text') {
      panelEl.style.display = 'none';
      return;
    }
    /* Auto-switch to text tool when a text element is selected */
    if (activeToolName !== 'text') activateTool('text');
    panelEl.style.display = '';

    /* Sync input values to current element */
    var tContent = document.getElementById('cxe-txt-content');
    var tFont    = document.getElementById('cxe-txt-font');
    var tSize    = document.getElementById('cxe-txt-size');
    var tBold    = document.getElementById('cxe-txt-bold');
    var tItalic  = document.getElementById('cxe-txt-italic');
    var tAlignL  = document.getElementById('cxe-txt-align-l');
    var tAlignC  = document.getElementById('cxe-txt-align-c');
    var tAlignR  = document.getElementById('cxe-txt-align-r');
    if (tContent && tContent.value !== elem.content) tContent.value = elem.content;
    if (tFont)   tFont.value = elem.font;
    if (tSize)   tSize.value = elem.size;
    if (tBold)   tBold.classList.toggle('is-active', !!elem.bold);
    if (tItalic) tItalic.classList.toggle('is-active', !!elem.italic);
    if (tAlignL) tAlignL.classList.toggle('is-active', elem.align === 'left');
    if (tAlignC) tAlignC.classList.toggle('is-active', elem.align === 'center');
    if (tAlignR) tAlignR.classList.toggle('is-active', elem.align === 'right');

    /* Color swatches */
    document.querySelectorAll('.cxe-txt-color-swatch').forEach(function (sw) {
      sw.classList.toggle('is-active', sw.dataset.color === elem.color);
    });
    /* Rotation */
    var tRot = document.getElementById('cxe-txt-rotation');
    if (tRot) tRot.value = Math.round(elem.rotation || 0);
  }

  /* ── Image edit panel (shown when an image element is selected) ── */
  function renderImageEditPanel() {
    var panelEl = document.getElementById('cxe-img-edit-panel');
    if (!panelEl) return;
    var elem = selectedElement();
    if (!elem || elem.type !== 'image') { panelEl.style.display = 'none'; return; }
    /* Auto-switch to upload tool when an image element is selected */
    if (activeToolName !== 'upload') activateTool('upload');
    panelEl.style.display = '';
    var rotIn = document.getElementById('cxe-img-rotation');
    if (rotIn) rotIn.value = Math.round(elem.rotation || 0);
    var bgBtn = document.getElementById('cxe-bg-remove-btn');
    if (bgBtn) {
      bgBtn.textContent = elem.bgRemoved ? '↩ Restore Original' : '🪄 Remove Background';
      bgBtn.classList.toggle('is-active', !!elem.bgRemoved);
    }
    var tolSlider = document.getElementById('cxe-bg-tolerance');
    if (tolSlider && !elem.bgRemoved) tolSlider.parentElement.style.display = 'none';
    else if (tolSlider)               tolSlider.parentElement.style.display = '';
  }

  function buildImageEditPanel() {
    return '<div class="cxe-img-edit-panel cxe-text-edit-panel" id="cxe-img-edit-panel" style="display:none">' +
           '<h3 class="cxe-section-label">Image Options</h3>' +
           '<div class="cxe-txt-row">' +
           '<label class="cxe-txt-mini-label">Rotate</label>' +
           '<input type="number" id="cxe-img-rotation" class="cxe-txt-num" value="0" min="0" max="360" step="1">' +
           '<span class="cxe-txt-mini-label">°</span>' +
           '<button type="button" class="cxe-ctrl-btn" id="cxe-img-rot-reset" style="padding:4px 8px">Reset</button>' +
           '</div>' +
           '<button type="button" class="cxe-add-text-btn" id="cxe-bg-remove-btn">🪄 Remove Background</button>' +
           '<div id="cxe-bg-tol-wrap" style="display:none">' +
           '<div class="cxe-txt-row" style="margin-top:6px">' +
           '<label class="cxe-txt-mini-label">Tolerance</label>' +
           '<input type="range" id="cxe-bg-tolerance" min="5" max="80" value="30" style="flex:1">' +
           '<span id="cxe-bg-tol-val" class="cxe-txt-mini-label">30</span>' +
           '</div>' +
           '<p class="cxe-colors-hint">Works best with solid-color backgrounds.</p>' +
           '</div>' +
           '<button type="button" class="cxe-txt-del-btn" id="cxe-img-delete" style="margin-top:4px">Delete Image</button>' +
           '</div>';
  }

  /* ── Background removal (client-side pixel manipulation) ──── */
  function getCornerColor(data, w, h) {
    function px(x, y) { var i=(y*w+x)*4; return {r:data[i],g:data[i+1],b:data[i+2]}; }
    var corners = [px(0,0), px(w-1,0), px(0,h-1), px(w-1,h-1)];
    var r=0,g=0,b=0;
    corners.forEach(function(c){r+=c.r;g+=c.g;b+=c.b;});
    return {r:Math.round(r/4), g:Math.round(g/4), b:Math.round(b/4)};
  }

  function removeBackground(imgElement, tolerance) {
    tolerance = tolerance || 30;
    var temp = document.createElement('canvas');
    temp.width  = imgElement.naturalWidth  || imgElement.width;
    temp.height = imgElement.naturalHeight || imgElement.height;
    var tctx = temp.getContext('2d');
    tctx.drawImage(imgElement, 0, 0);
    var imageData = tctx.getImageData(0, 0, temp.width, temp.height);
    var data = imageData.data;
    var bg = getCornerColor(data, temp.width, temp.height);
    for (var i = 0; i < data.length; i += 4) {
      if (Math.abs(data[i]-bg.r) < tolerance &&
          Math.abs(data[i+1]-bg.g) < tolerance &&
          Math.abs(data[i+2]-bg.b) < tolerance) {
        data[i+3] = 0;
      }
    }
    tctx.putImageData(imageData, 0, 0);
    return temp.toDataURL('image/png');
  }

  function applyBgRemoval(elem, tolerance) {
    if (!elem || !elem.imgLoaded || !elem.imgObj) return;
    if (!elem.originalBlobUrl) elem.originalBlobUrl = elem.blobUrl;
    var processedDataUrl = removeBackground(elem.imgObj, tolerance || 30);
    var newImg = new Image();
    newImg.onload = function () {
      elem.imgObj    = newImg;
      elem.imgLoaded = true;
      elem.bgRemoved = true;
      elem.processedUrl = processedDataUrl;
      Canvas.draw();
      renderImageEditPanel();
    };
    newImg.src = processedDataUrl;
  }

  function revertBgRemoval(elem) {
    if (!elem || !elem.originalBlobUrl) return;
    var src = elem.originalBlobUrl;
    var newImg = new Image();
    newImg.onload = function () {
      elem.imgObj    = newImg;
      elem.imgLoaded = true;
      elem.bgRemoved = false;
      elem.processedUrl = null;
      Canvas.draw();
      renderImageEditPanel();
    };
    newImg.src = src;
  }

  function buildTextEditPanel() {
    var fontOptions = TEXT_FONTS.map(function (f) {
      return '<option value="' + escHtml(f.value) + '">' + escHtml(f.label) + '</option>';
    }).join('');
    var colorSwatches = TEXT_COLORS.map(function (c) {
      var border = hexLuminance(c) > 0.82 ? 'box-shadow:inset 0 0 0 1px rgba(0,0,0,0.25);' : '';
      return '<button type="button" class="cxe-txt-color-swatch" data-color="' + c + '" ' +
             'style="background:' + c + ';' + border + '" aria-label="' + c + '"></button>';
    }).join('');
    return '<div class="cxe-text-edit-panel" id="cxe-text-edit-panel" style="display:none">' +
           '<h3 class="cxe-section-label">Edit Text</h3>' +
           '<textarea id="cxe-txt-content" class="cxe-textarea" rows="2" placeholder="Your text…" maxlength="200"></textarea>' +
           '<div class="cxe-txt-row">' +
           '<select id="cxe-txt-font" class="cxe-txt-select">' + fontOptions + '</select>' +
           '</div>' +
           '<div class="cxe-txt-row">' +
           '<label class="cxe-txt-mini-label">Size</label>' +
           '<input type="number" id="cxe-txt-size" class="cxe-txt-num" value="36" min="8" max="200">' +
           '<div class="cxe-txt-btn-group">' +
           '<button type="button" class="cxe-txt-fmt-btn" id="cxe-txt-bold" aria-label="Bold"><strong>B</strong></button>' +
           '<button type="button" class="cxe-txt-fmt-btn" id="cxe-txt-italic" aria-label="Italic"><em>I</em></button>' +
           '</div>' +
           '<div class="cxe-txt-btn-group">' +
           '<button type="button" class="cxe-txt-fmt-btn" id="cxe-txt-align-l" aria-label="Align left">≡</button>' +
           '<button type="button" class="cxe-txt-fmt-btn is-active" id="cxe-txt-align-c" aria-label="Align center">≡</button>' +
           '<button type="button" class="cxe-txt-fmt-btn" id="cxe-txt-align-r" aria-label="Align right">≡</button>' +
           '</div>' +
           '</div>' +
           '<div class="cxe-txt-colors">' + colorSwatches + '</div>' +
           '<div class="cxe-txt-row" style="margin-top:4px">' +
           '<label class="cxe-txt-mini-label">Rotate</label>' +
           '<input type="number" id="cxe-txt-rotation" class="cxe-txt-num" value="0" min="0" max="360" step="1">' +
           '<span class="cxe-txt-mini-label">°</span>' +
           '<button type="button" class="cxe-ctrl-btn" id="cxe-txt-rot-reset" style="padding:4px 8px">Reset</button>' +
           '</div>' +
           '<button type="button" class="cxe-txt-del-btn" id="cxe-txt-delete">Delete Text</button>' +
           '</div>';
  }

  /* ── Names & Numbers state ──────────────────────────────────── */
  var NN = {
    active: false,
    rows: [],   /* [{name,number,size}] */
    previewIdx: 0,
  };

  function nnRow(name, number, size) {
    return { name: name || '', number: number || '', size: size || '' };
  }

  function buildNamesNumbersSection() {
    return '<div class="cxe-panel" id="cxe-nn-section">' +
      '<h3 class="cxe-section-label">Names &amp; Numbers</h3>' +
      /* ── Inactive state ── */
      '<div id="cxe-nn-inactive">' +
        '<p class="cxe-nn-desc">Add individual names and numbers for each jersey. Each person becomes a separate line item with their size.</p>' +
        '<button type="button" class="cxe-nn-activate-btn" id="cxe-nn-activate-btn">Start Adding Names</button>' +
      '</div>' +
      /* ── Active state ── */
      '<div id="cxe-nn-active-panel" style="display:none">' +
        '<div class="cxe-nn-errors" id="cxe-nn-errors" style="display:none"></div>' +
        '<div class="cxe-nn-dup-warn" id="cxe-nn-dup-warn" style="display:none">Duplicate numbers detected — verify if intentional.</div>' +
        '<div class="cxe-nn-table-wrap">' +
          '<table class="cxe-nn-table">' +
            '<thead><tr>' +
              '<th class="cxe-nn-th">Name</th>' +
              '<th class="cxe-nn-th cxe-nn-th--num">No.</th>' +
              '<th class="cxe-nn-th">Size</th>' +
              '<th class="cxe-nn-th cxe-nn-th--del"></th>' +
            '</tr></thead>' +
            '<tbody id="cxe-nn-tbody"></tbody>' +
          '</table>' +
        '</div>' +
        '<div class="cxe-nn-actions">' +
          '<button type="button" class="cxe-nn-add-btn" id="cxe-nn-add-row-btn">+ Add row</button>' +
          '<button type="button" class="cxe-nn-import-btn-ui" id="cxe-nn-import-btn">Import CSV</button>' +
          '<input type="file" id="cxe-nn-csv-input" accept=".csv" style="display:none">' +
        '</div>' +
        '<div class="cxe-nn-summary" id="cxe-nn-summary"></div>' +
        '<button type="button" class="cxe-nn-cancel-btn" id="cxe-nn-deactivate-btn">Cancel Names &amp; Numbers</button>' +
      '</div>' +
    '</div>';
  }

  function nnSizes() {
    if (!S.product) return [];
    var variants = S.variantData;
    /* Filter by selected color so only available sizes show */
    if (S.colorOptionIdx >= 0 && S.selectedColor) {
      variants = variants.filter(function (v) {
        return getVariantOption(v, S.colorOptionIdx) === S.selectedColor;
      });
    }
    var seen = {}, out = [];
    variants.forEach(function (v) {
      var sz = S.sizeOptionIdx >= 0 ? getVariantOption(v, S.sizeOptionIdx) : null;
      if (sz && !seen[sz]) { seen[sz] = true; out.push(sz); }
    });
    return out;
  }

  function nnRowHasStock(row) {
    if (!row.size) return null;
    var v = S.variantData.find(function (vt) {
      var sz  = S.sizeOptionIdx  >= 0 ? getVariantOption(vt, S.sizeOptionIdx)  : null;
      var col = S.colorOptionIdx >= 0 ? getVariantOption(vt, S.colorOptionIdx) : null;
      return sz === row.size && (!S.selectedColor || col === S.selectedColor);
    });
    return v ? v.available : null;
  }

  function parseCsvLine(line) {
    var result = [], current = '', inQuote = false;
    for (var i = 0; i < line.length; i++) {
      var c = line[i];
      if (c === '"') {
        if (inQuote && line[i + 1] === '"') { current += '"'; i++; }
        else { inQuote = !inQuote; }
      } else if (c === ',' && !inQuote) {
        result.push(current); current = '';
      } else { current += c; }
    }
    result.push(current);
    return result;
  }

  function parseCSV(text) {
    /* Strip UTF-8 BOM */
    text = text.replace(/^﻿/, '');
    var lines = text.split(/\r?\n/);
    var rows = [], startLine = 0;
    if (lines.length > 0) {
      var firstCell = parseCsvLine(lines[0])[0].replace(/^"|"$/g, '').trim().toLowerCase();
      if (['name','player','first name','player name'].indexOf(firstCell) !== -1) startLine = 1;
    }
    for (var i = startLine; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line) continue;
      var cols = parseCsvLine(line);
      var name   = (cols[0] || '').replace(/^"|"$/g, '').trim();
      var number = (cols[1] || '').replace(/^"|"$/g, '').trim();
      var size   = (cols[2] || '').replace(/^"|"$/g, '').trim();
      if (name || number) rows.push({ name: name, number: number, size: size });
    }
    return rows;
  }

  function showCsvPreviewModal(parsedRows) {
    var modal = document.getElementById('cxe-csv-preview-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cxe-csv-preview-modal';
      modal.className = 'cxe-templates-modal';
      document.body.appendChild(modal);
    }
    var sizes = nnSizes();
    var valid = parsedRows.filter(function (r) { return r.name || r.number; });
    if (!valid.length) { showToast('No valid rows found in CSV.'); return; }

    var trows = valid.map(function (r) {
      var sizeWarn = r.size && sizes.indexOf(r.size) === -1 ? ' — size not found' : '';
      return '<tr style="border-bottom:1px solid rgba(255,255,255,.05)">' +
        '<td style="padding:6px 10px">' + escHtml(r.name) + '</td>' +
        '<td style="padding:6px 10px;text-align:center">' + escHtml(r.number) + '</td>' +
        '<td style="padding:6px 10px">' + escHtml(r.size) + '<span style="color:#F59E0B;font-size:.6875rem">' + escHtml(sizeWarn) + '</span></td>' +
        '</tr>';
    }).join('');
    var th = function (t) { return '<th style="text-align:left;padding:6px 10px 8px;font-size:.625rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--cxe-muted);border-bottom:1px solid var(--cxe-border)">' + t + '</th>'; };

    modal.innerHTML =
      '<div class="cxe-templates-inner" style="max-width:480px">' +
      '<div class="cxe-templates-header"><h2>Import ' + valid.length + ' ' + (valid.length === 1 ? 'person' : 'people') + ' from CSV</h2>' +
      '<button type="button" class="cxe-templates-close" id="cxe-csv-close">&#10005;</button></div>' +
      '<div style="overflow-y:auto;max-height:280px"><table style="width:100%;border-collapse:collapse;font-size:.8125rem"><thead><tr>' +
      th('Name') + th('Number') + th('Size') + '</tr></thead><tbody>' + trows + '</tbody></table></div>' +
      '<div style="display:flex;gap:8px;padding:14px 20px;border-top:1px solid var(--cxe-border)">' +
      '<button type="button" class="cxe-atc-btn" id="cxe-csv-confirm" style="height:40px;font-size:.875rem;flex:1">Import ' + valid.length + ' rows</button>' +
      '<button type="button" class="cxe-design-action-btn" id="cxe-csv-cancel" style="padding:8px 16px">Cancel</button>' +
      '</div></div>';

    modal.classList.remove('is-hidden');
    modal.querySelector('#cxe-csv-close').addEventListener('click', function () { modal.classList.add('is-hidden'); });
    modal.querySelector('#cxe-csv-cancel').addEventListener('click', function () { modal.classList.add('is-hidden'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.add('is-hidden'); });
    modal.querySelector('#cxe-csv-confirm').addEventListener('click', function () {
      var avail = nnSizes();
      NN.rows = valid.map(function (r) {
        return nnRow(r.name, r.number, avail.indexOf(r.size) !== -1 ? r.size : (avail[0] || ''));
      });
      NN.previewIdx = 0;
      renderNNTable();
      updateNNPreview();
      modal.classList.add('is-hidden');
      showToast(valid.length + ' ' + (valid.length === 1 ? 'person' : 'people') + ' imported.');
    });
  }

  function renderNNTable() {
    var tbody = document.getElementById('cxe-nn-tbody');
    if (!tbody) return;
    tbody.innerHTML = '';
    var sizes = nnSizes();

    /* Detect duplicate numbers */
    var numCounts = {};
    NN.rows.forEach(function (r) { if (r.number) numCounts[r.number] = (numCounts[r.number] || 0) + 1; });
    var hasDups = Object.keys(numCounts).some(function (n) { return numCounts[n] > 1; });
    var dupEl = document.getElementById('cxe-nn-dup-warn');
    if (dupEl) dupEl.style.display = hasDups ? '' : 'none';

    var tabBase = 100; /* tabindex base so it doesn't conflict with other page elements */
    NN.rows.forEach(function (row, i) {
      var stockOk = nnRowHasStock(row);
      var isDup   = row.number && numCounts[row.number] > 1;
      var sizeOpts = '<option value="">— size —</option>' + sizes.map(function (sz) {
        return '<option value="' + escHtml(sz) + '"' + (row.size === sz ? ' selected' : '') + '>' + escHtml(sz) + '</option>';
      }).join('');

      var tr = document.createElement('tr');
      tr.className = 'cxe-nn-row' + (i % 2 === 1 ? ' cxe-nn-row--alt' : '') + (stockOk === false ? ' cxe-nn-row--warn' : '');

      tr.innerHTML =
        '<td class="cxe-nn-td">' +
          '<input type="text" class="cxe-nn-input" data-nn-field="name" data-nn-idx="' + i + '"' +
          ' value="' + escHtml(row.name) + '" placeholder="Name" tabindex="' + (tabBase + i * 3) + '">' +
        '</td>' +
        '<td class="cxe-nn-td cxe-nn-td--num">' +
          '<input type="text" class="cxe-nn-input cxe-nn-input--num' + (isDup ? ' cxe-nn-input--dup' : '') + '"' +
          ' data-nn-field="number" data-nn-idx="' + i + '"' +
          ' value="' + escHtml(row.number) + '" placeholder="00" tabindex="' + (tabBase + i * 3 + 1) + '">' +
        '</td>' +
        '<td class="cxe-nn-td cxe-nn-td--size">' +
          '<select class="cxe-nn-select" data-nn-field="size" data-nn-idx="' + i + '"' +
          ' tabindex="' + (tabBase + i * 3 + 2) + '">' + sizeOpts + '</select>' +
          (stockOk === false ? '<span class="cxe-nn-stock-warn">Out of stock</span>' : '') +
        '</td>' +
        '<td class="cxe-nn-td cxe-nn-td--del">' +
          '<button type="button" class="cxe-nn-del-btn" data-nn-del="' + i + '" tabindex="-1" aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</td>';

      tbody.appendChild(tr);
    });

    renderNNSummary();
    updateNNPreviewBar();
    updateAtcButton();
  }

  function renderNNSummary() {
    var el = document.getElementById('cxe-nn-summary');
    if (!el) return;
    var n = NN.rows.length;
    if (!n) { el.innerHTML = ''; return; }
    var label = n + ' ' + (n === 1 ? 'person' : 'people');
    if (window.CustPricing && S.method && S.printSizeKey && S.garmentCents) {
      var pfu = window.CustPricing.getPrintFeePerUnit(S.method, S.printSizeKey);
      var sf  = window.CustPricing.getSetupFee(S.method);
      var cf  = window.CustPricing.getColorFee(S.method, S.numColors);
      var perShirt = S.garmentCents + pfu;
      var total    = perShirt * n + sf + cf;
      el.innerHTML = label + ' &times; ' + fmt(perShirt) + '/shirt' +
        (sf + cf > 0 ? ' + ' + fmt(sf + cf) + ' setup' : '') +
        ' = <strong>' + fmt(total) + '</strong>';
    } else {
      el.textContent = label + ' — choose options above to see total';
    }
  }

  function updateNNPreviewBar() {
    var bar = document.getElementById('cxe-nn-preview-bar');
    if (!bar) return;
    if (!NN.active || !NN.rows.length) { bar.hidden = true; return; }
    bar.hidden = false;
    if (NN.previewIdx >= NN.rows.length) NN.previewIdx = 0;
    var row = NN.rows[NN.previewIdx] || {};
    var n   = NN.rows.length;
    var label = document.getElementById('cxe-nn-preview-label');
    var prev  = document.getElementById('cxe-nn-preview-prev');
    var next  = document.getElementById('cxe-nn-preview-next');
    if (label) {
      var nameStr = row.name || '—';
      var numStr  = row.number ? ' (#' + row.number + ')' : '';
      label.textContent = 'Previewing: ' + nameStr + numStr + ' — ' + (NN.previewIdx + 1) + ' of ' + n;
    }
    if (prev) prev.disabled = NN.previewIdx === 0;
    if (next) next.disabled = NN.previewIdx === n - 1;
  }

  /* Alias for backward-compat (called from legacy spots) */
  function updateNNNav() { updateNNPreviewBar(); }

  function updateNNPreview() {
    if (!NN.active || !NN.rows.length) return;
    var row = NN.rows[NN.previewIdx] || {};
    ['front', 'back'].forEach(function (side) {
      DS[side].elements.forEach(function (e) {
        if (e.type !== 'text') return;
        if (e._nnPlaceholder === 'name')   e.content = row.name   || 'NAME';
        if (e._nnPlaceholder === 'number') e.content = row.number || '00';
      });
    });
    Canvas.draw();
    updateNNPreviewBar();
  }

  function nnActivate() {
    NN.active = true;
    var inactive = document.getElementById('cxe-nn-inactive');
    var active   = document.getElementById('cxe-nn-active-panel');
    if (inactive) inactive.style.display = 'none';
    if (active)   active.style.display   = '';
    if (NN.rows.length === 0) {
      NN.rows.push(nnRow('', '', nnSizes()[0] || ''));
    }
    renderNNTable();
    addNNPlaceholders();
  }

  function nnDeactivate() {
    NN.active = false;
    NN.rows = [];
    NN.previewIdx = 0;
    var inactive = document.getElementById('cxe-nn-inactive');
    var active   = document.getElementById('cxe-nn-active-panel');
    if (inactive) inactive.style.display = '';
    if (active)   active.style.display   = 'none';
    /* Remove placeholder elements from canvas */
    ['front', 'back'].forEach(function (side) {
      DS[side].elements = DS[side].elements.filter(function (e) { return !e._nnPlaceholder; });
    });
    Canvas.draw();
    renderElementsList();
    updateNNPreviewBar();
    updateAtcButton();
  }

  function attachNNListeners() {
    /* Activate */
    var activateBtn = document.getElementById('cxe-nn-activate-btn');
    if (activateBtn) activateBtn.addEventListener('click', nnActivate);

    /* Deactivate */
    var deactivateBtn = document.getElementById('cxe-nn-deactivate-btn');
    if (deactivateBtn) deactivateBtn.addEventListener('click', nnDeactivate);

    /* Add row */
    var addRowBtn = document.getElementById('cxe-nn-add-row-btn');
    if (addRowBtn) {
      addRowBtn.addEventListener('click', function () {
        NN.rows.push(nnRow('', '', nnSizes()[0] || ''));
        renderNNTable();
        /* Focus the name input of the new row */
        var inputs = document.querySelectorAll('#cxe-nn-tbody .cxe-nn-input[data-nn-field="name"]');
        var last = inputs[inputs.length - 1];
        if (last) last.focus();
      });
    }

    /* CSV import */
    var importBtn = document.getElementById('cxe-nn-import-btn');
    var csvInput  = document.getElementById('cxe-nn-csv-input');
    if (importBtn && csvInput) {
      importBtn.addEventListener('click', function () { csvInput.click(); });
      csvInput.addEventListener('change', function () {
        var file = csvInput.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (ev) {
          var parsed = parseCSV(ev.target.result || '');
          showCsvPreviewModal(parsed);
        };
        reader.readAsText(file);
        csvInput.value = '';
      });
    }

    /* Preview bar navigation */
    var previewPrev = document.getElementById('cxe-nn-preview-prev');
    var previewNext = document.getElementById('cxe-nn-preview-next');
    if (previewPrev) {
      previewPrev.addEventListener('click', function () {
        if (NN.previewIdx > 0) { NN.previewIdx--; updateNNPreview(); }
      });
    }
    if (previewNext) {
      previewNext.addEventListener('click', function () {
        if (NN.previewIdx < NN.rows.length - 1) { NN.previewIdx++; updateNNPreview(); }
      });
    }

    /* Table delegation */
    var wrap = document.getElementById('cxe-nn-section');
    if (wrap) {
      wrap.addEventListener('input', function (e) {
        var el    = e.target;
        var idx   = parseInt(el.dataset.nnIdx, 10);
        var field = el.dataset.nnField;
        if (isNaN(idx) || !field || !NN.rows[idx]) return;
        NN.rows[idx][field] = el.value;
        if (field === 'name' || field === 'number') {
          updateNNPreview();
          renderNNSummary();
          /* Re-render duplicate warning without full table rebuild */
          var numCounts = {};
          NN.rows.forEach(function (r) { if (r.number) numCounts[r.number] = (numCounts[r.number] || 0) + 1; });
          var hasDups = Object.keys(numCounts).some(function (n) { return numCounts[n] > 1; });
          var dupEl = document.getElementById('cxe-nn-dup-warn');
          if (dupEl) dupEl.style.display = hasDups ? '' : 'none';
          /* Update dup highlight on individual input */
          el.classList.toggle('cxe-nn-input--dup', !!(field === 'number' && el.value && numCounts[el.value] > 1));
        }
      });
      wrap.addEventListener('change', function (e) {
        var el    = e.target;
        var idx   = parseInt(el.dataset.nnIdx, 10);
        var field = el.dataset.nnField;
        if (isNaN(idx) || !field || !NN.rows[idx]) return;
        NN.rows[idx][field] = el.value;
        if (field === 'size') { renderNNTable(); updateAtcButton(); }
      });
      wrap.addEventListener('click', function (e) {
        var delBtn = e.target.closest('[data-nn-del]');
        if (delBtn) {
          var idx = parseInt(delBtn.dataset.nnDel, 10);
          NN.rows.splice(idx, 1);
          if (NN.previewIdx >= NN.rows.length) NN.previewIdx = Math.max(0, NN.rows.length - 1);
          if (NN.rows.length === 0) { NN.rows.push(nnRow('', '', nnSizes()[0] || '')); }
          renderNNTable();
          updateNNPreview();
        }
      });
    }
  }

  function addNNPlaceholders() {
    /* Only add if no placeholders already exist on either side */
    var alreadyHas = DS.front.elements.some(function (e) { return e._nnPlaceholder; }) ||
                     DS.back.elements.some(function (e) { return e._nnPlaceholder; });
    if (alreadyHas) return;
    saveState();
    var pos       = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25, y:0.20, w:0.50, h:0.40 };
    var firstRow  = NN.rows[0] || {};
    var nameText  = firstRow.name   || 'SMITH';
    var numText   = firstRow.number || '23';
    /* Add to back canvas — jersey names/numbers go on the back */
    DS.back.elements.push({
      id: nextElId(), type:'text', content: nameText,
      font:'Impact', size:34, scale:1, color:'#FFFFFF', rotation:0,
      bold:false, italic:false, align:'center',
      x: pos.x + pos.w / 2, y: pos.y + pos.h * 0.22,
      _nnPlaceholder: 'name',
    });
    DS.back.elements.push({
      id: nextElId(), type:'text', content: numText,
      font:'Impact', size:60, scale:1, color:'#FFFFFF', rotation:0,
      bold:true, italic:false, align:'center',
      x: pos.x + pos.w / 2, y: pos.y + pos.h * 0.55,
      _nnPlaceholder: 'number',
    });
    /* Switch to back view so user sees the placeholders */
    selectSide('back');
    Canvas.draw();
    renderElementsList();
    updateAtcButton();
  }

  /* ── Templates ───────────────────────────────────────────────── */
  function buildTemplatesSection() {
    return '<div class="cxe-panel" id="cxe-templates-section">' +
           '<h3 class="cxe-section-label">Templates</h3>' +
           '<button type="button" class="cxe-add-text-btn" id="cxe-templates-btn">Browse Templates</button>' +
           '</div>';
  }

  function openTemplatesModal() {
    var tpls = window.EDITOR_TEMPLATES;
    if (!tpls || !tpls.length) return;
    var modal = document.getElementById('cxe-templates-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cxe-templates-modal';
      modal.className = 'cxe-templates-modal';
      document.body.appendChild(modal);
    }
    var cats = ['All'].concat(tpls.reduce(function (acc, t) {
      if (acc.indexOf(t.category) === -1) acc.push(t.category);
      return acc;
    }, []));
    var catBtns = cats.map(function (c) {
      return '<button type="button" class="cxe-templates-cat-btn' + (c === 'All' ? ' is-active' : '') +
             '" data-cat="' + escHtml(c) + '">' + escHtml(c) + '</button>';
    }).join('');
    var cards = tpls.map(function (t) {
      var bg = t.front.elements.length > 0 ? (t.front.elements[0].color || '#FFFFFF') : '#555';
      var preview = '<svg viewBox="0 0 80 107" xmlns="http://www.w3.org/2000/svg">' +
        '<rect width="80" height="107" rx="4" fill="#222"/>' +
        t.front.elements.map(function (e, ei) {
          var y = 30 + ei * 28;
          return '<text x="40" y="' + y + '" text-anchor="middle" font-size="8" fill="' + escHtml(e.color || '#FFF') + '" font-family="sans-serif">' +
                 escHtml(e.content.length > 12 ? e.content.slice(0,12)+'…' : e.content) + '</text>';
        }).join('') + '</svg>';
      return '<div class="cxe-template-card" data-template-id="' + escHtml(t.id) + '" data-cat="' + escHtml(t.category) + '">' +
             '<div class="cxe-template-thumb">' + preview + '</div>' +
             '<div class="cxe-template-name">' + escHtml(t.name) + '</div>' +
             '<div class="cxe-template-cat">' + escHtml(t.category) + '</div></div>';
    }).join('');

    modal.innerHTML =
      '<div class="cxe-templates-inner">' +
      '<div class="cxe-templates-header"><h2>Choose a Template</h2>' +
      '<button type="button" class="cxe-templates-close" id="cxe-templates-close">&#10005;</button></div>' +
      '<div class="cxe-templates-cats" id="cxe-templates-cats">' + catBtns + '</div>' +
      '<div class="cxe-templates-grid" id="cxe-templates-grid">' + cards + '</div>' +
      '</div>';

    modal.classList.remove('is-hidden');

    modal.querySelector('#cxe-templates-close').addEventListener('click', function () {
      modal.classList.add('is-hidden');
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) modal.classList.add('is-hidden');
    });
    modal.querySelector('#cxe-templates-cats').addEventListener('click', function (e) {
      var btn = e.target.closest('.cxe-templates-cat-btn');
      if (!btn) return;
      modal.querySelectorAll('.cxe-templates-cat-btn').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      var cat = btn.dataset.cat;
      modal.querySelectorAll('.cxe-template-card').forEach(function (card) {
        card.style.display = (cat === 'All' || card.dataset.cat === cat) ? '' : 'none';
      });
    });
    modal.querySelector('#cxe-templates-grid').addEventListener('click', function (e) {
      var card = e.target.closest('.cxe-template-card');
      if (!card) return;
      var tid = card.dataset.templateId;
      var tpl = (window.EDITOR_TEMPLATES || []).find(function (t) { return t.id === tid; });
      if (!tpl) return;
      var hasElements = DS.front.elements.length > 0 || DS.back.elements.length > 0;
      if (hasElements && !confirm('Replace the current design with this template?')) return;
      applyTemplate(tpl);
      modal.classList.add('is-hidden');
    });
  }

  function applyTemplate(tpl) {
    saveState();
    var pos = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25, y:0.20, w:0.50, h:0.40 };
    ['front','back'].forEach(function (side) {
      DS[side].elements = (tpl[side] && tpl[side].elements || []).map(function (e) {
        /* Convert normalized [0,1] x/y from template to absolute canvas fractions */
        var cx = pos.x + e.x * pos.w;
        var cy = pos.y + e.y * pos.h;
        /* Already absolute if in 0-1 range — use as-is since template defines x/y as canvas fractions */
        return {
          id: nextElId(), type: e.type,
          content: e.content, font: e.font || 'Space Grotesk',
          size: e.size || 36, scale: e.scale || 1,
          color: e.color || '#FFFFFF', rotation: e.rotation || 0,
          bold: !!e.bold, italic: !!e.italic, align: e.align || 'center',
          x: e.x, y: e.y,
          _nnPlaceholder: e.content === '{{NAME}}' ? 'name' : e.content === '{{NUMBER}}' ? 'number' : undefined,
        };
      });
    });
    /* Load Google fonts needed by template */
    var allEls = DS.front.elements.concat(DS.back.elements);
    allEls.forEach(function (e) {
      var f = TEXT_FONTS.find(function (tf) { return tf.value === e.font; });
      if (f && f.google) loadGoogleFont(f.value);
    });
    selectedElId = null;
    Canvas.draw();
    renderElementsList();
    renderTextPanel();
    updateAtcButton();
    showToast('Template applied!');
  }

  function attachTemplatesListeners() {
    var btn = document.getElementById('cxe-templates-btn');
    if (btn) btn.addEventListener('click', openTemplatesModal);
  }

  /* ── Save / Load / Share ─────────────────────────────────────── */
  var autoSaveTimer = null;

  function serializeDesign() {
    return {
      productHandle: S.product ? S.product.handle : null,
      selectedColor: S.selectedColor,
      method: S.method,
      location: S.location,
      locationKey: S.locationKey,
      printSize: S.printSize,
      printSizeKey: S.printSizeKey,
      quantity: S.quantity,
      notes: S.notes,
      savedAt: new Date().toISOString(),
      front: DS.front.elements.map(function (e) {
        var c = {}; for (var k in e) { if (k !== 'imgObj') c[k] = e[k]; } return c;
      }),
      back: DS.back.elements.map(function (e) {
        var c = {}; for (var k in e) { if (k !== 'imgObj') c[k] = e[k]; } return c;
      }),
    };
  }

  function saveDesign() {
    var design = serializeDesign();
    try {
      var saved = JSON.parse(sessionStorage.getItem('drp_saved_designs') || '[]');
      saved.unshift(design);
      if (saved.length > 5) saved = saved.slice(0, 5);
      sessionStorage.setItem('drp_saved_designs', JSON.stringify(saved));
    } catch (e) { console.warn('[cxe] save failed:', e.message); }
    showToast('Design saved!');
  }

  function startAutoSave() {
    if (autoSaveTimer) clearInterval(autoSaveTimer);
    autoSaveTimer = setInterval(function () {
      if (hasAnyElement()) {
        try {
          var design = serializeDesign();
          sessionStorage.setItem('drp_autosave', JSON.stringify(design));
        } catch (e) {}
      }
    }, 30000);
  }

  function loadDesignState(design) {
    saveState();
    ['front','back'].forEach(function (side) {
      DS[side].elements = (design[side] || []).map(function (e) {
        e.imgObj    = null;
        e.imgLoaded = false;
        if (e.type === 'image') {
          var src = e.blobUrl || e.processedUrl || e.url;
          if (src) {
            var img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () { e.imgObj = img; e.imgLoaded = true; Canvas.draw(); };
            img.src = src;
          }
        } else {
          var f = TEXT_FONTS.find(function (tf) { return tf.value === e.font; });
          if (f && f.google) loadGoogleFont(f.value);
        }
        return e;
      });
    });
    selectedElId = null;
    Canvas.draw();
    renderElementsList();
    renderTextPanel();
    updateAtcButton();
  }

  function openLoadModal() {
    var modal = document.getElementById('cxe-load-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cxe-load-modal';
      modal.className = 'cxe-load-modal';
      document.body.appendChild(modal);
    }
    var saved = [];
    try { saved = JSON.parse(sessionStorage.getItem('drp_saved_designs') || '[]'); } catch (e) {}
    /* Also check autosave */
    try {
      var auto = JSON.parse(sessionStorage.getItem('drp_autosave') || 'null');
      if (auto) saved.unshift(Object.assign({}, auto, { _isAutosave: true }));
    } catch (e) {}

    var rows = saved.length
      ? saved.map(function (d, i) {
          var date = d.savedAt ? new Date(d.savedAt).toLocaleString() : 'Unknown';
          var label = d._isAutosave ? 'Auto-save' : ('Saved ' + date);
          var product = d.productHandle || 'unknown product';
          return '<div class="cxe-saved-design-row" data-load-idx="' + i + '">' +
                 '<div class="cxe-saved-design-row__info">' +
                 '<div class="cxe-saved-design-row__name">' + escHtml(label) + '</div>' +
                 '<div class="cxe-saved-design-row__meta">' + escHtml(product) + '</div>' +
                 '</div>' +
                 '</div>';
        }).join('')
      : '<p style="color:var(--cxe-muted);font-size:.875rem;padding:8px 0;">No saved designs found.</p>';

    modal.innerHTML =
      '<div class="cxe-load-inner">' +
      '<div class="cxe-load-header"><h2>Load Design</h2>' +
      '<button type="button" class="cxe-templates-close" id="cxe-load-close">&#10005;</button></div>' +
      '<div class="cxe-load-body">' + rows +
      '<label style="display:flex;align-items:center;gap:8px;padding:10px 12px;background:rgba(26,26,26,.6);border:1px dashed rgba(107,107,107,.35);border-radius:8px;cursor:pointer;font-size:.8125rem;color:var(--cxe-muted)">' +
      'Upload .json file' +
      '<input type="file" id="cxe-load-json-input" accept=".json" style="display:none">' +
      '</label>' +
      '</div></div>';

    modal.classList.remove('is-hidden');
    modal.querySelector('#cxe-load-close').addEventListener('click', function () { modal.classList.add('is-hidden'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.add('is-hidden'); });
    modal.querySelector('.cxe-load-body').addEventListener('click', function (e) {
      var row = e.target.closest('[data-load-idx]');
      if (!row) return;
      var idx = parseInt(row.dataset.loadIdx, 10);
      loadDesignState(saved[idx]);
      modal.classList.add('is-hidden');
      showToast('Design loaded!');
    });
    var jsonIn = modal.querySelector('#cxe-load-json-input');
    if (jsonIn) {
      jsonIn.addEventListener('change', function () {
        var file = jsonIn.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function (ev) {
          try {
            var design = JSON.parse(ev.target.result);
            loadDesignState(design);
            modal.classList.add('is-hidden');
            showToast('Design loaded!');
          } catch (e) { alert('Invalid design file.'); }
        };
        reader.readAsText(file);
      });
    }
  }

  function downloadDesign() {
    var design = serializeDesign();
    var blob = new Blob([JSON.stringify(design, null, 2)], { type: 'application/json' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href   = url;
    a.download = 'drp-design-' + Date.now() + '.json';
    a.click();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  function openShareModal() {
    var modal = document.getElementById('cxe-share-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'cxe-share-modal';
      modal.className = 'cxe-share-modal';
      document.body.appendChild(modal);
    }
    var frontDataUrl = Canvas.captureSide('front');
    var backDataUrl  = DS.back.elements.length > 0 ? Canvas.captureSide('back') : null;
    var previewsHtml = '';
    if (frontDataUrl) {
      previewsHtml += '<div class="cxe-share-preview-wrap"><span>Front</span><img src="' + frontDataUrl + '" alt="Front mockup"></div>';
    }
    if (backDataUrl) {
      previewsHtml += '<div class="cxe-share-preview-wrap"><span>Back</span><img src="' + backDataUrl + '" alt="Back mockup"></div>';
    }
    modal.innerHTML =
      '<div class="cxe-share-inner">' +
      '<div class="cxe-share-header"><h2>Share Design</h2>' +
      '<button type="button" class="cxe-templates-close" id="cxe-share-close">&#10005;</button></div>' +
      '<div class="cxe-share-body">' +
      '<div class="cxe-share-previews">' + previewsHtml + '</div>' +
      '<div class="cxe-share-btns">' +
      (frontDataUrl ? '<button type="button" class="cxe-design-action-btn is-primary" id="cxe-share-dl-front">Download Front</button>' : '') +
      (backDataUrl  ? '<button type="button" class="cxe-design-action-btn" id="cxe-share-dl-back">Download Back</button>' : '') +
      '<button type="button" class="cxe-design-action-btn" id="cxe-share-email">Email</button>' +
      '</div>' +
      '<p style="font-size:.75rem;color:var(--cxe-muted)">Send these images to anyone who needs to approve the design before you place the order.</p>' +
      '</div></div>';

    modal.classList.remove('is-hidden');
    modal.querySelector('#cxe-share-close').addEventListener('click', function () { modal.classList.add('is-hidden'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.add('is-hidden'); });
    var dlFront = modal.querySelector('#cxe-share-dl-front');
    if (dlFront) dlFront.addEventListener('click', function () { downloadDataUrl(frontDataUrl, 'mockup-front.png'); });
    var dlBack = modal.querySelector('#cxe-share-dl-back');
    if (dlBack) dlBack.addEventListener('click', function () { downloadDataUrl(backDataUrl, 'mockup-back.png'); });
    var emailBtn = modal.querySelector('#cxe-share-email');
    if (emailBtn) emailBtn.addEventListener('click', function () {
      window.location.href = 'mailto:?subject=' + encodeURIComponent('My Custom Design — DRP Media') +
        '&body=' + encodeURIComponent('Hi!\n\nPlease review my custom design at dropmedia.ca/pages/customize\n\nI\'ve downloaded the mockup images to attach.');
    });
  }

  function downloadDataUrl(dataUrl, filename) {
    if (!dataUrl) return;
    var a = document.createElement('a');
    a.href = dataUrl; a.download = filename; a.click();
  }

  function buildDesignActionsSection() {
    return '<div class="cxe-panel" id="cxe-design-actions-section">' +
           '<h3 class="cxe-section-label">Design Actions</h3>' +
           '<div class="cxe-design-actions">' +
           '<button type="button" class="cxe-design-action-btn is-primary" id="cxe-save-design-btn">Save</button>' +
           '<button type="button" class="cxe-design-action-btn" id="cxe-load-design-btn">Load</button>' +
           '<button type="button" class="cxe-design-action-btn" id="cxe-download-design-btn">Export</button>' +
           '<button type="button" class="cxe-design-action-btn" id="cxe-share-design-btn">Share</button>' +
           '</div></div>';
  }

  function attachDesignActionListeners() {
    var saveBtn     = document.getElementById('cxe-save-design-btn');
    var loadBtn     = document.getElementById('cxe-load-design-btn');
    var downloadBtn = document.getElementById('cxe-download-design-btn');
    var shareBtn    = document.getElementById('cxe-share-design-btn');
    if (saveBtn)     saveBtn.addEventListener('click', saveDesign);
    if (loadBtn)     loadBtn.addEventListener('click', openLoadModal);
    if (downloadBtn) downloadBtn.addEventListener('click', downloadDesign);
    if (shareBtn)    shareBtn.addEventListener('click', openShareModal);
  }

  /* ── Toast ───────────────────────────────────────────────────── */
  function showToast(msg) {
    var toast = document.getElementById('cxe-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cxe-toast';
      toast.className = 'cxe-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    setTimeout(function () { toast.classList.remove('is-visible'); }, 2500);
  }

  /* ── Tool tab system ─────────────────────────────────────────── */
  var ALL_TOOL_PANEL_IDS = [
    'cxe-color-section', 'cxe-size-section', 'cxe-qty-section',
    'cxe-method-section', 'cxe-colors-section', 'cxe-location-section',
    'cxe-psize-section', 'cxe-upload-section', 'cxe-text-section',
    'cxe-graphics-section', 'cxe-el-list-section', 'cxe-nn-section',
    'cxe-templates-section', 'cxe-design-actions-section',
    'cxe-text-edit-panel', 'cxe-img-edit-panel',
  ];

  var TOOL_PANELS = {
    colors:    ['cxe-color-section'],
    size:      ['cxe-size-section'],
    qty:       ['cxe-qty-section'],
    method:    ['cxe-method-section'],
    location:  ['cxe-location-section'],
    psize:     ['cxe-psize-section'],
    upload:    ['cxe-upload-section'],
    text:      ['cxe-text-section', 'cxe-el-list-section'],
    graphics:  ['cxe-graphics-section', 'cxe-el-list-section'],
    names:     ['cxe-nn-section'],
    templates: ['cxe-templates-section'],
    save:      ['cxe-design-actions-section'],
  };

  var TOOL_META = {
    colors:    { label: 'Colors' },
    size:      { label: 'Size' },
    qty:       { label: 'Quantity' },
    method:    { label: 'Print Method' },
    location:  { label: 'Location' },
    psize:     { label: 'Print Size' },
    upload:    { label: 'Upload Artwork' },
    text:      { label: 'Text' },
    graphics:  { label: 'Graphics' },
    names:     { label: 'Names & Numbers' },
    templates: { label: 'Templates' },
    save:      { label: 'Save / Load' },
  };

  function activateTool(name) {
    if (!TOOL_PANELS[name]) return;
    activeToolName = name;

    /* Hide all tool panels */
    ALL_TOOL_PANEL_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });

    /* Show panels for this tool */
    (TOOL_PANELS[name] || []).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = '';
    });

    /* For method tool: re-apply colors-section visibility based on current method */
    if (name === 'method') {
      var cs = document.getElementById('cxe-colors-section');
      if (cs) cs.style.display = (S.method === 'Screen Printing' || S.method === 'Vinyl') ? '' : 'none';
    }

    /* Update toolbar icon active state */
    document.querySelectorAll('.cxe-toolbar__icon').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.tool === name);
    });

    /* Update ctx panel header */
    var meta = TOOL_META[name];
    if (meta) {
      var titlEl = document.getElementById('cxe-ctx-title');
      if (titlEl) titlEl.textContent = meta.label;
    }

    /* Show ctx panel if collapsed */
    var ctxPanel = document.getElementById('cxe-ctx-panel');
    if (ctxPanel) ctxPanel.classList.remove('is-collapsed');
  }

  function initToolTabs() {
    /* Hide all panels initially */
    ALL_TOOL_PANEL_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.style.display = 'none';
    });

    /* Open the first tool */
    activateTool(activeToolName || 'colors');

    /* Toolbar icon clicks */
    document.querySelectorAll('.cxe-toolbar__icon').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tool = btn.dataset.tool;
        if (!tool) return;
        var ctxPanel = document.getElementById('cxe-ctx-panel');
        var collapsed = ctxPanel && ctxPanel.classList.contains('is-collapsed');
        if (activeToolName === tool && !collapsed) {
          /* Re-click active tool → collapse panel */
          if (ctxPanel) ctxPanel.classList.add('is-collapsed');
          btn.classList.remove('is-active');
          activeToolName = '';
        } else {
          activateTool(tool);
        }
      });
    });

    /* Close button */
    var closeBtn = document.getElementById('cxe-ctx-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        var ctxPanel = document.getElementById('cxe-ctx-panel');
        if (ctxPanel) ctxPanel.classList.add('is-collapsed');
        document.querySelectorAll('.cxe-toolbar__icon').forEach(function (b) {
          b.classList.remove('is-active');
        });
        activeToolName = '';
      });
    }
  }

  /* ── Accordion (kept for reference; replaced by initToolTabs) ── */
  function initAccordion() {
    var defs = [
      { id:'cxe-color-section',            icon:'🎨', label:'COLOR',          open:true  },
      { id:'cxe-size-section',             icon:'📏', label:'SIZE',           open:true  },
      { id:'cxe-qty-section',              icon:'🔢', label:'QUANTITY',       open:true  },
      { id:'cxe-method-section',           icon:'🖨',  label:'PRINT METHOD',  open:true  },
      { id:'cxe-location-section',         icon:'🎯', label:'LOCATION',       open:false },
      { id:'cxe-psize-section',            icon:'📐', label:'PRINT SIZE',     open:false },
      { id:'cxe-upload-section',           icon:'📤', label:'UPLOAD ARTWORK', open:false },
      { id:'cxe-text-section',             icon:'✏️', label:'ADD TEXT',       open:false },
      { id:'cxe-graphics-section',         icon:'🎭', label:'GRAPHICS',       open:false },
      { id:'cxe-nn-section',               icon:'👥', label:'NAMES & NUMBERS',open:false },
      { id:'cxe-templates-section',        icon:'📋', label:'TEMPLATES',      open:false },
      { id:'cxe-design-actions-section',   icon:'💾', label:'SAVE / LOAD',    open:false },
    ];

    defs.forEach(function (def) {
      var panel = document.getElementById(def.id);
      if (!panel) return;

      /* Collect children: exclude .cxe-section-label h3 (becomes the header) */
      var allChildren = Array.prototype.slice.call(panel.childNodes);
      var bodyChildren = allChildren.filter(function (n) {
        return !(n.nodeType === 1 && n.classList && n.classList.contains('cxe-section-label'));
      });

      /* Build collapsible body */
      var body = document.createElement('div');
      body.className = 'cxe-accordion-body';
      if (!def.open) body.style.maxHeight = '0px';
      bodyChildren.forEach(function (n) { body.appendChild(n); });

      /* Build header button */
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cxe-accordion-header' + (def.open ? ' is-open' : '');
      btn.setAttribute('aria-expanded', def.open ? 'true' : 'false');
      btn.innerHTML =
        '<span class="cxe-accordion-icon" aria-hidden="true">' + def.icon + '</span>' +
        '<span class="cxe-accordion-label">' + escHtml(def.label) + '</span>' +
        '<svg class="cxe-accordion-chevron" viewBox="0 0 12 12" width="12" height="12" fill="none" aria-hidden="true">' +
        '<path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      btn.addEventListener('click', function () {
        var wasOpen = btn.classList.contains('is-open');
        if (wasOpen) {
          /* Closing */
          body.style.maxHeight = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.maxHeight = '0px'; });
          btn.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          /* Opening */
          body.style.maxHeight = body.scrollHeight + 'px';
          btn.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var onEnd = function () {
            if (btn.classList.contains('is-open')) body.style.maxHeight = 'none';
            body.removeEventListener('transitionend', onEnd);
          };
          body.addEventListener('transitionend', onEnd);
        }
      });

      /* Rebuild panel as accordion */
      while (panel.firstChild) panel.removeChild(panel.firstChild);
      panel.classList.add('cxe-accordion');
      panel.classList.remove('cxe-panel');
      panel.appendChild(btn);
      panel.appendChild(body);
    });
  }

  /* ── buildLeftRail ──────────────────────────────────────────── */
  function buildLeftRail(product, injectedColorMap) {
    var colorOptionIdx = -1, sizeOptionIdx = -1;
    var opts = product.options || [];
    console.log('[cxe] product.options:', JSON.stringify(opts));
    console.log('[cxe] variants[0]:', JSON.stringify(product.variants && product.variants[0]));
    opts.forEach(function (o, i) {
      var name = (o !== null && typeof o === 'object') ? String(o.name || '') : String(o != null ? o : '');
      var lc   = name.toLowerCase().trim();
      if (lc === 'color' || lc === 'colour') colorOptionIdx = i;
      if (lc === 'size') sizeOptionIdx = i;
    });
    console.log('[cxe] colorIdx:', colorOptionIdx, 'sizeIdx:', sizeOptionIdx);
    S.colorOptionIdx = colorOptionIdx; S.sizeOptionIdx = sizeOptionIdx;
    S.variantData = product.variants || [];

    S.colorImageMap = {}; S.backImageMap = {};

    /* Build unique color list in variant order. */
    var colorValues = [];
    if (colorOptionIdx >= 0) {
      var seen = {};
      S.variantData.forEach(function (v) {
        var c = getVariantOption(v, colorOptionIdx);
        if (c && !seen[c]) { seen[c] = true; colorValues.push(c); }
      });
    }
    console.log('[cxe] colorValues (' + colorValues.length + '):', colorValues.slice(0, 5));

    /* ── Step 1: group product.images by S&S numeric ID ────────────
       S&S filenames:  {id}_f_fl.jpg  (front)
                       {id}_b_fl.jpg  (back)
                       {id}_fl.jpg    (style/model shot)
       Front and back that share the same ID belong to the same color.  */
    function extractImageId(url) {
      var filename = url.split('/').pop().split('?')[0];
      var m = filename.match(/^(\d+)/);
      return m ? m[1] : null;
    }

    var imageGroups = {};
    (product.images || []).forEach(function (imgEntry) {
      var url = typeof imgEntry === 'string' ? imgEntry : (imgEntry && (imgEntry.src || ''));
      if (!url) return;
      var id = extractImageId(url);
      if (!id) return;
      var filename = url.split('/').pop().split('?')[0].toLowerCase();
      if (!imageGroups[id]) imageGroups[id] = {};
      if (filename.indexOf('_f_') !== -1) {
        imageGroups[id].front = url;
      } else if (filename.indexOf('_b_') !== -1) {
        imageGroups[id].back = url;
      } else {
        imageGroups[id].style = url;
      }
    });
    console.log('[cxe] imageGroups:', Object.keys(imageGroups).length, 'groups');
    var sampleEntry = Object.entries(imageGroups)[0];
    if (sampleEntry) console.log('[cxe] sample group id=' + sampleEntry[0] + ':', JSON.stringify(sampleEntry[1]).slice(0, 120));

    /* ── Step 2: build colorImageMap ───────────────────────────── */
    var hasFlatInjected = injectedColorMap && Object.keys(injectedColorMap).length > 0;

    if (hasFlatInjected) {
      /* Primary path: use the server-side Liquid map from the product page HTML.
         This is the same data that main-product.liquid uses and is always correct. */
      colorValues.forEach(function (color) {
        if (injectedColorMap[color]) S.colorImageMap[color] = injectedColorMap[color];
      });
      console.log('[cxe] colorImageMap from Liquid HTML:', Object.keys(S.colorImageMap).length, 'colors');

      /* Back images: match each front URL's S&S numeric ID to the _b_ counterpart in imageGroups */
      colorValues.forEach(function (color) {
        var frontUrl = S.colorImageMap[color];
        if (!frontUrl) return;
        var id = extractImageId(frontUrl);
        if (id && imageGroups[id] && imageGroups[id].back) {
          S.backImageMap[color] = imageGroups[id].back;
        }
      });
    } else {
      /* Fallback path: AJAX data only (variant.featured_image + positional) */
      S.variantData.forEach(function (v) {
        var color = colorOptionIdx >= 0 ? getVariantOption(v, colorOptionIdx) : null;
        if (!color || S.colorImageMap[color]) return;
        if (v.featured_image) {
          var fSrc = v.featured_image.src || v.featured_image;
          var id   = extractImageId(fSrc);
          if (id && imageGroups[id]) {
            S.colorImageMap[color] = imageGroups[id].front || imageGroups[id].style || fSrc;
            if (imageGroups[id].back) S.backImageMap[color] = imageGroups[id].back;
          } else {
            S.colorImageMap[color] = fSrc;
          }
        }
      });

      var frontGroups = Object.entries(imageGroups)
        .filter(function (e) { return e[1].front; })
        .sort(function (a, b) { return parseInt(a[0], 10) - parseInt(b[0], 10); });

      colorValues.forEach(function (color, i) {
        if (S.colorImageMap[color]) return;
        if (frontGroups[i]) {
          S.colorImageMap[color] = frontGroups[i][1].front;
          if (frontGroups[i][1].back) S.backImageMap[color] = frontGroups[i][1].back;
        }
      });
    }

    /* frontGroups still needed for default canvas image below */
    var frontGroups = Object.entries(imageGroups)
      .filter(function (e) { return e[1].front; })
      .sort(function (a, b) { return parseInt(a[0], 10) - parseInt(b[0], 10); });

    console.log('[cxe] colorImageMap (' + Object.keys(S.colorImageMap).length + '):', JSON.stringify(S.colorImageMap).slice(0, 200));
    console.log('[cxe] backImageMap  (' + Object.keys(S.backImageMap).length  + '):', JSON.stringify(S.backImageMap).slice(0, 200));
    window.__backImageMap = S.backImageMap;

    /* ── Set initial canvas base images ── */
    var firstGroup = frontGroups[0];
    var defaultFrontUrl = (hasFlatInjected && colorValues.length > 0 && S.colorImageMap[colorValues[0]])
      || (firstGroup && firstGroup[1].front)
      || (typeof product.featured_image === 'string' ? product.featured_image : null)
      || (product.featured_image && product.featured_image.src)
      || null;
    if (defaultFrontUrl) {
      console.log('[cxe] default front base:', defaultFrontUrl.slice(0, 80));
      Canvas.setBase('front', defaultFrontUrl);
    } else {
      console.warn('[cxe] no front image — product.images count:', (product.images || []).length);
    }

    var defaultBackUrl = (firstGroup && firstGroup[1].back) || null;
    if (defaultBackUrl) {
      console.log('[cxe] default back base:', defaultBackUrl.slice(0, 80));
      Canvas.setBase('back', defaultBackUrl);
    }

    var html = '';
    if (colorValues.length > 0) html += buildColorSection(colorValues);
    html += buildSizeSection();
    html += buildQtySection();
    html += buildMethodSection();
    html += buildColorsSection();
    html += buildLocationSection();
    html += buildPrintSizeSection();
    html += buildUploadSection();
    html += buildGraphicsSection();
    html += buildTextSection();
    html += buildNamesNumbersSection();
    html += buildTemplatesSection();
    html += buildDesignActionsSection();
    html += buildElementsList();
    html += buildTextEditPanel();
    html += buildImageEditPanel();
    leftEl.innerHTML = html;

    attachColorListeners();
    attachQtyListeners();
    attachMethodListeners();
    attachColorsListeners();
    attachLocationListeners();
    attachPrintSizeListeners();
    attachUploadListeners();
    attachTextListeners();
    attachImageEditListeners();
    attachGraphicsListeners();
    attachNNListeners();
    attachTemplatesListeners();
    attachDesignActionListeners();
    startAutoSave();
    initToolTabs();

    var firstColor = colorValues[0] || null;
    rebuildSizes(firstColor);
    if (colorValues.length === 1) selectColor(colorValues[0]);

    selectLocation('Front', 'front');
    renderElementsList();
  }

  /* ── Action: color ──────────────────────────────────────────── */
  function selectColor(name) {
    S.selectedColor = name;
    console.log('[cxe] selectColor:', name, 'frontUrl:', (S.colorImageMap[name] || '').slice(-40), 'backUrl:', (S.backImageMap[name] || '').slice(-40));
    document.querySelectorAll('.cxe-swatch').forEach(function (sw) {
      sw.classList.toggle('is-selected', sw.dataset.color === name);
    });
    var swName = document.getElementById('cxe-swatch-name');
    if (swName) swName.textContent = name || '';
    renderColorGallery(name);
    var pfi = S.product && S.product.featured_image;
    /* product.images is string[] — no .src property */
    var firstProductImg = S.product && S.product.images && typeof S.product.images[0] === 'string'
      ? S.product.images[0] : null;
    var frontUrl = S.colorImageMap[name]
      || (pfi ? (typeof pfi === 'string' ? pfi : pfi.src) : null)
      || firstProductImg
      || null;
    if (frontUrl) Canvas.setBase('front', frontUrl);

    var backUrl = S.backImageMap[name] || null;
    if (backUrl) Canvas.setBase('back', backUrl);

    /* Update view toggle thumbnails */
    var fThumb = document.getElementById('cxe-view-front-thumb');
    var bThumb = document.getElementById('cxe-view-back-thumb');
    if (fThumb && frontUrl) fThumb.style.backgroundImage = 'url(' + frontUrl + ')';
    if (bThumb && backUrl)  bThumb.style.backgroundImage = 'url(' + backUrl + ')';

    rebuildSizes(name);
    if (S.selectedSize) {
      var kept = document.querySelector('.cxe-sizes .cxe-size-btn[data-size="' + CSS.escape(S.selectedSize) + '"]:not(:disabled)');
      if (kept) kept.classList.add('is-selected');
      else { S.selectedSize = ''; S.selectedVariantId = 0; S.garmentCents = 0; }
    }
    updateAtcButton();
  }

  /* ── Action: size ───────────────────────────────────────────── */
  function selectSize(size, variantId, priceCents) {
    S.selectedSize = size; S.selectedVariantId = variantId; S.garmentCents = priceCents;
    document.querySelectorAll('.cxe-size-btn').forEach(function (b) {
      b.classList.toggle('is-selected', b.dataset.size === size && parseInt(b.dataset.variantId, 10) === variantId);
    });
    updateAtcButton();
  }

  /* ── Action: method ─────────────────────────────────────────── */
  function selectMethod(method) {
    S.method = method; S.numColors = 1;
    document.querySelectorAll('.cxe-method-card').forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.method === method);
    });
    var cs = document.getElementById('cxe-colors-section');
    if (cs) cs.style.display = (activeToolName === 'method' && (method === 'Screen Printing' || method === 'Vinyl')) ? '' : 'none';
    var cv = document.getElementById('cxe-colors-val');
    if (cv) cv.textContent = '1';
    updateMethodWarning(); updateMethodRec(); updateAtcButton();
  }

  function updateMethodWarning() {
    var wEl = document.getElementById('cxe-method-warning');
    if (!wEl) return;
    var w = '';
    if (S.method === 'Screen Printing' && S.quantity < 24) w = 'Screen printing requires min. 24 units.';
    else if (S.method === 'Vinyl' && S.numColors > 4)      w = 'Vinyl max 4 colors. Consider DTF.';
    else if (S.method === 'Vinyl')                          w = 'Vinyl does not support gradients.';
    wEl.textContent = w; wEl.style.display = w ? '' : 'none';
    var hEl = document.getElementById('cxe-colors-hint');
    if (hEl && window.CustPricing) {
      if (S.method === 'Screen Printing') {
        hEl.textContent = S.numColors + ' color' + (S.numColors === 1 ? '' : 's') +
          ' — separation: ' + fmt(window.CustPricing.getColorFee(S.method, S.numColors)) + ' (one-time)';
      } else if (S.method === 'Vinyl') {
        hEl.textContent = S.numColors + ' color' + (S.numColors === 1 ? '' : 's') + (S.numColors > 4 ? ' — max 4' : '');
      } else { hEl.textContent = ''; }
    }
  }

  function updateMethodRec() {
    var rEl = document.getElementById('cxe-method-rec');
    if (!rEl) return;
    rEl.textContent = methodRecText(S.quantity);
    rEl.style.display = '';
  }

  function updateMethodCards() {
    document.querySelectorAll('.cxe-method-card').forEach(function (card) {
      var minQty  = parseInt(card.dataset.minQty, 10) || 1;
      var disabled = S.quantity < minQty;
      card.classList.toggle('is-disabled', disabled);
      var badge = card.querySelector('.cxe-method-card__badge');
      if (disabled) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'cxe-method-card__badge'; card.appendChild(badge); }
        badge.textContent = 'Min. ' + minQty;
      } else if (badge) { badge.remove(); }
      if (disabled && S.method === card.dataset.method) {
        S.method = '';
        document.querySelectorAll('.cxe-method-card').forEach(function (c) { c.classList.remove('is-selected'); });
        var cs = document.getElementById('cxe-colors-section');
        if (cs) cs.style.display = 'none';
      }
    });
  }

  /* ── Action: location ───────────────────────────────────────── */
  function selectLocation(label, key) {
    S.location = label; S.locationKey = key;
    document.querySelectorAll('.cxe-loc-card').forEach(function (c) {
      c.classList.toggle('is-selected', c.dataset.key === key);
    });
    var isDesigner = key === 'designers_choice';
    if (designersMsgEl) designersMsgEl.hidden = !isDesigner;
    if (canvasEl) canvasEl.style.opacity = isDesigner ? '0' : '1';
    Canvas.setLocation(key);
    updateAtcButton();
  }

  /* ── Action: print size ─────────────────────────────────────── */
  function selectPrintSize(label, key) {
    S.printSize = label; S.printSizeKey = key;
    document.querySelectorAll('.cxe-psize-btn').forEach(function (b) {
      b.classList.toggle('is-selected', b.dataset.key === key);
    });
    Canvas.draw();
    updateAtcButton();
  }

  /* ── Listeners ──────────────────────────────────────────────── */
  function attachColorListeners() {
    document.querySelectorAll('.cxe-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () { selectColor(sw.dataset.color); });
    });
  }

  function attachQtyListeners() {
    var qIn = document.getElementById('cxe-qty-input');
    var qm  = document.getElementById('cxe-qty-minus');
    var qp  = document.getElementById('cxe-qty-plus');
    function setQty(v) {
      S.quantity = Math.max(1, v || 1);
      if (qIn) qIn.value = S.quantity;
      updateMethodCards(); updateMethodWarning(); updateMethodRec(); updateAtcButton();
    }
    if (qIn) { qIn.addEventListener('change', function () { setQty(parseInt(qIn.value,10)); });
               qIn.addEventListener('input',  function () { setQty(parseInt(qIn.value,10)); }); }
    if (qm) qm.addEventListener('click', function () { setQty(S.quantity - 1); });
    if (qp) qp.addEventListener('click', function () { setQty(S.quantity + 1); });
  }

  function attachMethodListeners() {
    document.querySelectorAll('.cxe-method-card').forEach(function (card) {
      card.addEventListener('click', function () {
        if (!card.classList.contains('is-disabled')) selectMethod(card.dataset.method);
      });
    });
  }

  function attachColorsListeners() {
    var cm = document.getElementById('cxe-colors-minus');
    var cp = document.getElementById('cxe-colors-plus');
    var cv = document.getElementById('cxe-colors-val');
    function setColors(v) {
      S.numColors = Math.max(1, Math.min(S.method === 'Vinyl' ? 4 : 12, v));
      if (cv) cv.textContent = String(S.numColors);
      updateMethodWarning(); updateAtcButton();
    }
    if (cm) cm.addEventListener('click', function () { setColors(S.numColors - 1); });
    if (cp) cp.addEventListener('click', function () { setColors(S.numColors + 1); });
  }

  function attachLocationListeners() {
    document.querySelectorAll('.cxe-loc-card').forEach(function (card) {
      card.addEventListener('click', function () { selectLocation(card.dataset.location, card.dataset.key); });
    });
  }

  function attachPrintSizeListeners() {
    document.querySelectorAll('.cxe-psize-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectPrintSize(btn.dataset.size, btn.dataset.key); });
    });
  }

  function attachTextListeners() {
    /* Add Text button */
    var addBtn = document.getElementById('cxe-add-text-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var pos = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25,y:0.20,w:0.50,h:0.40 };
        var newEl = {
          id: nextElId(), type: 'text',
          content: 'Your Text', font: 'Space Grotesk',
          size: 36, scale: 1.0, color: '#FFFFFF', rotation: 0,
          bold: false, italic: false, align: 'center',
          x: pos.x + pos.w / 2, y: pos.y + pos.h / 2,
        };
        Canvas.addElement(newEl);
        renderTextPanel();
      });
    }

    var txtSaveDebounce;
    leftEl.addEventListener('input', function (e) {
      var elem = selectedElement();
      if (!elem || elem.type !== 'text') return;
      if (e.target.id === 'cxe-txt-content') {
        elem.content = e.target.value;
        Canvas.draw(); renderElementsList();
        clearTimeout(txtSaveDebounce);
        txtSaveDebounce = setTimeout(saveState, 500);
      }
      if (e.target.id === 'cxe-txt-size') {
        elem.size = Math.max(8, parseInt(e.target.value, 10) || 36);
        Canvas.draw();
      }
      if (e.target.id === 'cxe-txt-rotation') {
        elem.rotation = ((parseInt(e.target.value, 10) || 0) % 360 + 360) % 360;
        Canvas.draw();
      }
    });

    leftEl.addEventListener('change', function (e) {
      var elem = selectedElement();
      if (!elem || elem.type !== 'text') return;
      if (e.target.id === 'cxe-txt-font') {
        elem.font = e.target.value;
        var fontObj = TEXT_FONTS.find(function (f) { return f.value === e.target.value; });
        if (fontObj && fontObj.google) loadGoogleFont(fontObj.value);
        Canvas.draw(); saveState();
      }
      if (e.target.id === 'cxe-txt-size' || e.target.id === 'cxe-txt-rotation') { saveState(); }
    });

    leftEl.addEventListener('click', function (e) {
      var elem = selectedElement();
      var btn  = e.target.closest('button');
      if (!btn) return;
      if (btn.id === 'cxe-txt-bold')    { if (elem && elem.type==='text') { elem.bold = !elem.bold; Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-italic')  { if (elem && elem.type==='text') { elem.italic = !elem.italic; Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-align-l') { if (elem && elem.type==='text') { elem.align = 'left';   Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-align-c') { if (elem && elem.type==='text') { elem.align = 'center'; Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-align-r') { if (elem && elem.type==='text') { elem.align = 'right';  Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-rot-reset') { if (elem && elem.type==='text') { elem.rotation=0; Canvas.draw(); renderTextPanel(); saveState(); } }
      if (btn.id === 'cxe-txt-delete')  { if (elem) Canvas.removeElement(elem.id); }
      if (btn.classList.contains('cxe-txt-color-swatch')) {
        if (elem && elem.type === 'text') { elem.color = btn.dataset.color; Canvas.draw(); renderTextPanel(); saveState(); }
      }
    });

    document.addEventListener('keydown', function (e) {
      var tag = document.activeElement.tagName;
      if (['INPUT','TEXTAREA','SELECT'].indexOf(tag) !== -1) return;
      /* Delete/Backspace */
      if (e.key === 'Delete' || e.key === 'Backspace') {
        if (selectedElId) { Canvas.removeElement(selectedElId); e.preventDefault(); }
      }
      /* Undo: Ctrl+Z / Cmd+Z */
      if ((e.ctrlKey || e.metaKey) && !e.shiftKey && e.key === 'z') { undo(); e.preventDefault(); }
      /* Redo: Ctrl+Shift+Z / Cmd+Shift+Z */
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'z')  { redo(); e.preventDefault(); }
    });
  }

  /* ── Image edit panel listeners ─────────────────────────────── */
  function attachImageEditListeners() {
    leftEl.addEventListener('input', function (e) {
      var elem = selectedElement();
      if (!elem || elem.type !== 'image') return;
      if (e.target.id === 'cxe-img-rotation') {
        elem.rotation = ((parseInt(e.target.value, 10) || 0) % 360 + 360) % 360;
        Canvas.draw();
      }
      if (e.target.id === 'cxe-bg-tolerance') {
        var tolVal = document.getElementById('cxe-bg-tol-val');
        if (tolVal) tolVal.textContent = e.target.value;
        if (elem.bgRemoved) applyBgRemoval(elem, parseInt(e.target.value, 10));
      }
    });
    leftEl.addEventListener('change', function (e) {
      var elem = selectedElement();
      if (!elem || elem.type !== 'image') return;
      if (e.target.id === 'cxe-img-rotation') saveState();
    });
    leftEl.addEventListener('click', function (e) {
      var elem = selectedElement();
      var btn  = e.target.closest('button');
      if (!btn) return;
      if (btn.id === 'cxe-img-rot-reset') {
        if (elem && elem.type === 'image') { elem.rotation = 0; Canvas.draw(); renderImageEditPanel(); saveState(); }
      }
      if (btn.id === 'cxe-bg-remove-btn') {
        if (!elem || elem.type !== 'image') return;
        saveState();
        if (elem.bgRemoved) {
          revertBgRemoval(elem);
        } else {
          var tol = parseInt((document.getElementById('cxe-bg-tolerance') || {}).value || 30, 10);
          applyBgRemoval(elem, tol);
        }
        var wrap = document.getElementById('cxe-bg-tol-wrap');
        if (wrap) wrap.style.display = elem.bgRemoved ? 'none' : '';
      }
      if (btn.id === 'cxe-img-delete') {
        if (elem) Canvas.removeElement(elem.id);
      }
    });
  }

  /* ── Graphics library ────────────────────────────────────────── */
  function buildGraphicsSection() {
    var graphics = window.EDITOR_GRAPHICS;
    if (!graphics) return '';
    var cats = Object.keys(graphics);
    if (!cats.length) return '';
    var html = '<div class="cxe-panel" id="cxe-graphics-section">';
    html += '<h3 class="cxe-section-label">Graphics</h3>';
    cats.forEach(function (cat) {
      html += '<div class="cxe-graphics-cat-label">' + escHtml(cat) + '</div>';
      html += '<div class="cxe-graphics-grid">';
      graphics[cat].forEach(function (g) {
        html += '<button type="button" class="cxe-graphic-btn" data-svg="' + escHtml(g.svg) +
                '" data-name="' + escHtml(g.name) + '" title="' + escHtml(g.name) + '">' +
                g.svg.replace(/currentColor/g, '#F6F6F1') + '</button>';
      });
      html += '</div>';
    });
    html += '</div>';
    return html;
  }

  function attachGraphicsListeners() {
    leftEl.addEventListener('click', function (e) {
      var btn = e.target.closest('.cxe-graphic-btn');
      if (!btn) return;
      var svgStr  = btn.dataset.svg || '';
      var name    = btn.dataset.name || 'Graphic';
      var colored = svgStr.replace(/currentColor/g, '#FFFFFF');
      var blob    = new Blob([colored], { type: 'image/svg+xml' });
      var blobUrl = URL.createObjectURL(blob);
      var pos     = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25,y:0.20,w:0.50,h:0.40 };
      var elData  = {
        id: nextElId(), type: 'image',
        url: '', filename: name, blobUrl: blobUrl,
        imgObj: null, imgLoaded: false, rotation: 0,
        x: pos.x + pos.w / 2, y: pos.y + pos.h / 2, scale: 1.0,
        isGraphic: true, svgStr: svgStr,
      };
      var img = new Image();
      img.onload = function () { elData.imgObj = img; elData.imgLoaded = true; Canvas.draw(); };
      img.src = blobUrl;
      Canvas.addElement(elData);
    });
  }

  /* ── Upload ─────────────────────────────────────────────────── */
  function attachUploadListeners() {
    var zone      = document.getElementById('cxe-upload-zone');
    var fileInput = document.getElementById('cxe-file-input');
    if (!zone || !fileInput) return;

    zone.addEventListener('click', function (e) {
      if (!e.target.closest('#cxe-upload-progress')) fileInput.click();
    });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
    });
    zone.addEventListener('dragover',  function (e) { e.preventDefault(); zone.classList.add('is-drag-over'); });
    zone.addEventListener('dragleave', function ()  { zone.classList.remove('is-drag-over'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault(); zone.classList.remove('is-drag-over');
      var file = e.dataTransfer && e.dataTransfer.files[0];
      if (file) handleFile(file);
    });
    fileInput.addEventListener('change', function () {
      if (fileInput.files[0]) handleFile(fileInput.files[0]);
    });
  }

  function setFileError(msg) {
    var el = document.getElementById('cxe-file-error');
    if (el) { el.textContent = msg; el.style.display = msg ? '' : 'none'; }
  }

  function setResWarning(show) {
    var el = document.getElementById('cxe-res-warning');
    if (el) el.style.display = show ? '' : 'none';
  }

  function validateFile(file) {
    var allowed = ['application/pdf','image/jpeg','image/png','image/svg+xml'];
    if (allowed.indexOf(file.type) === -1) { setFileError('Please upload a PDF, JPG, PNG, or SVG.'); return false; }
    if (file.size > 25*1024*1024)          { setFileError('File must be under 25 MB.');              return false; }
    setFileError(''); return true;
  }

  function checkResolution(file) {
    if (file.type === 'application/pdf' || file.type === 'image/svg+xml') return;
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () { setResWarning(Math.min(img.naturalWidth, img.naturalHeight) < 1500); URL.revokeObjectURL(url); };
    img.src = url;
  }

  function handleFile(file) {
    if (!validateFile(file)) return;
    if (!MIDDLEWARE_URL) { setFileError('File upload not configured. Contact the store admin.'); return; }
    S.uploading = true;
    var zone = document.getElementById('cxe-upload-zone');
    var prog = document.getElementById('cxe-upload-progress');
    if (zone) zone.classList.add('is-uploading');
    if (prog) prog.style.display = '';
    updateAtcButton();

    var reader = new FileReader();
    reader.onerror = function () {
      S.uploading = false;
      if (zone) zone.classList.remove('is-uploading');
      if (prog) prog.style.display = 'none';
      setFileError('Failed to read file.'); updateAtcButton();
    };
    reader.onload = function (ev) {
      var dataUrl = ev.target.result;
      var b64     = dataUrl.split(',')[1];
      fetch(MIDDLEWARE_URL + '/artwork-uploads', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filename: file.name, mimeType: file.type, data: b64 }),
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.error||'Upload failed'); }); return r.json(); })
        .then(function (json) {
          S.uploading = false;
          if (zone) zone.classList.remove('is-uploading');
          if (prog) prog.style.display = 'none';

          /* Reset upload zone */
          var idleEl = document.getElementById('cxe-upload-idle');
          if (idleEl) idleEl.innerHTML = '<strong>✓ ' + escHtml(json.filename.slice(0,28)) + '</strong><br><small>Click to upload another</small>';

          /* Create image element */
          var pos = (window.CUSTOMIZER_POSITIONS || {})[S.locationKey] || { x:0.25,y:0.20,w:0.50,h:0.40 };
          var elData = {
            id: nextElId(), type: 'image',
            url: json.url, filename: json.filename,
            blobUrl: dataUrl, originalBlobUrl: dataUrl, processedUrl: null, bgRemoved: false,
            imgObj: null, imgLoaded: false, rotation: 0,
            x: pos.x + pos.w / 2, y: pos.y + pos.h / 2, scale: 1.0,
          };
          /* Load image object */
          var imgObj = new Image();
          imgObj.crossOrigin = 'anonymous';
          imgObj.onload = function () { elData.imgObj = imgObj; elData.imgLoaded = true; Canvas.draw(); };
          imgObj.src = dataUrl;
          Canvas.addElement(elData);
          checkResolution(file); updateAtcButton();
        })
        .catch(function (err) {
          S.uploading = false;
          if (zone) zone.classList.remove('is-uploading');
          if (prog) prog.style.display = 'none';
          setFileError('Upload failed: ' + (err.message||'Unknown error')); updateAtcButton();
        });
    };
    reader.readAsDataURL(file);
  }

  /* ── Add to Cart ─────────────────────────────────────────────── */
  function uploadMockup(dataUrl, variantId, side) {
    var b64 = dataUrl.split(',')[1];
    if (!b64 || !MIDDLEWARE_URL) return Promise.resolve(null);
    return fetch(MIDDLEWARE_URL + '/artwork-uploads', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: 'mockup-' + side + '-' + variantId + '-' + Date.now() + '.png',
        mimeType: 'image/png', data: b64,
      }),
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.url ? j.url : null; })
      .catch(function (e) { console.warn('[cxe] mockup upload failed:', e.message); return null; });
  }

  function captureAllMockups(variantId) {
    var frontDataUrl = DS.front.elements.length > 0 ? Canvas.captureSide('front') : null;
    var backDataUrl  = DS.back.elements.length  > 0 ? Canvas.captureSide('back')  : null;
    var promises = [
      frontDataUrl ? uploadMockup(frontDataUrl, variantId, 'front') : Promise.resolve(null),
      backDataUrl  ? uploadMockup(backDataUrl,  variantId, 'back')  : Promise.resolve(null),
    ];
    return Promise.all(promises).then(function (results) {
      return { front: results[0], back: results[1] };
    });
  }

  function showAtcError(msg) {
    if (atcErrEl) { atcErrEl.textContent = msg; atcErrEl.hidden = !msg; }
  }

  function setAtcLoading(on) {
    S.atcLoading = on;
    [atcBtn, mobileAtcBtn].forEach(function (b) {
      if (!b) return;
      if (on) { b.classList.add('is-loading'); b.disabled = true; b.textContent = 'Adding…'; }
      else    { b.classList.remove('is-loading'); }
    });
  }

  /* ── Bulk Names & Numbers add to cart ──────────────────────── */
  function doAddToCartBulk() {
    setAtcLoading(true);
    captureAllMockups(S.selectedVariantId)
      .then(function (mockups) {
        var pfu = window.CustPricing ? window.CustPricing.getPrintFeePerUnit(S.method, S.printSizeKey) : 0;
        var sf  = window.CustPricing ? window.CustPricing.getSetupFee(S.method) : 0;
        var cf  = window.CustPricing ? window.CustPricing.getColorFee(S.method, S.numColors) : 0;

        var items = NN.rows.map(function (row, i) {
          var vid = getVariantIdForSize(row.size);
          var props = {
            'Print Method':        S.method,
            'Print Location':      S.location,
            'Print Size':          S.printSize,
            'Player Name':         row.name,
            'Player Number':       row.number,
            '_mockup_url_front':   mockups.front || '',
            '_mockup_url_back':    mockups.back  || '',
            '_mockup_url':         mockups.front || mockups.back || '',
            '_print_fee_per_unit': String(pfu),
            '_copyright_accepted': 'true',
          };
          /* Setup / color fees only on first item */
          if (i === 0) {
            props['_setup_fee'] = String(sf);
            props['_color_fee'] = String(cf);
          } else {
            props['_setup_fee'] = '0';
            props['_color_fee'] = '0';
          }
          if (S.notes.trim()) props['Customization Notes'] = S.notes.trim();
          return { id: vid, quantity: 1, properties: props };
        });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items }),
        });
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart.'); });
        return r.json();
      })
      .then(function () {
        setAtcLoading(false);
        [atcBtn, mobileAtcBtn].forEach(function (b) {
          if (!b) return; b.classList.add('is-success'); b.textContent = 'Added! ✓'; b.disabled = false;
        });
        setTimeout(function () { window.location.href = '/cart'; }, 1500);
      })
      .catch(function (err) {
        setAtcLoading(false);
        showAtcError((err && err.message) || 'Could not add to cart. Please try again.');
        updateAtcButton();
      });
  }

  /* Resolve variant ID for a given size name */
  function getVariantIdForSize(sizeName) {
    var v = S.variantData.find(function (vt) {
      var sz = S.sizeOptionIdx >= 0 ? getVariantOption(vt, S.sizeOptionIdx) : null;
      var col = S.colorOptionIdx >= 0 ? getVariantOption(vt, S.colorOptionIdx) : null;
      return sz === sizeName && (!S.selectedColor || col === S.selectedColor) && vt.available;
    });
    return v ? v.id : S.selectedVariantId;
  }

  function doAddToCart() {
    showAtcError('');
    var variantId = parseInt(S.selectedVariantId, 10);
    if (!variantId || isNaN(variantId)) { showAtcError('Select a size and color.'); return; }
    if (!S.copyright) {
      if (copyrightErrEl) { copyrightErrEl.hidden = false; copyrightErrEl.scrollIntoView({ behavior:'smooth', block:'center' }); }
      return;
    }

    /* Names & Numbers bulk add */
    if (NN.active && NN.rows.length > 0) {
      doAddToCartBulk();
      return;
    }

    setAtcLoading(true);

    captureAllMockups(variantId)
      .then(function (mockups) {
        var pfu = window.CustPricing ? window.CustPricing.getPrintFeePerUnit(S.method, S.printSizeKey) : 0;
        var sf  = window.CustPricing ? window.CustPricing.getSetupFee(S.method) : 0;
        var cf  = window.CustPricing ? window.CustPricing.getColorFee(S.method, S.numColors) : 0;

        /* Collect artwork URLs from image elements */
        var allEls   = DS.front.elements.concat(DS.back.elements);
        var imgEls   = allEls.filter(function (e) { return e.type === 'image'; });
        var artworkUrls  = imgEls.map(function (e) { return e.url; }).join(', ');
        var artFilenames = imgEls.map(function (e) { return e.filename || ''; }).join(', ');

        /* Text content summaries */
        var txtFront = DS.front.elements.filter(function (e) { return e.type==='text'; }).map(function (e) { return e.content; }).join(', ');
        var txtBack  = DS.back.elements.filter( function (e) { return e.type==='text'; }).map(function (e) { return e.content; }).join(', ');

        var sidesUsed = [];
        if (DS.front.elements.length > 0) sidesUsed.push('Front');
        if (DS.back.elements.length  > 0) sidesUsed.push('Back');
        var locationLabel = sidesUsed.length > 1 ? 'Front and Back' : (sidesUsed[0] || S.location);

        var properties = {
          'Print Method':        S.method,
          'Print Location':      locationLabel,
          'Print Size':          S.printSize,
          '_setup_fee':          String(sf),
          '_color_fee':          String(cf),
          '_print_fee_per_unit': String(pfu),
          '_quantity':           String(S.quantity),
          '_artwork_url':        artworkUrls,
          '_artwork_filename':   artFilenames,
          '_mockup_url_front':   mockups.front || '',
          '_mockup_url_back':    mockups.back  || '',
          /* Legacy field for admin dashboard compat */
          '_mockup_url':         mockups.front || mockups.back || '',
          '_copyright_accepted': 'true',
          '_copyright_accepted_at': new Date().toISOString(),
        };
        if (txtFront) properties['_text_content_front'] = txtFront;
        if (txtBack)  properties['_text_content_back']  = txtBack;
        if (S.method === 'Screen Printing' || S.method === 'Vinyl') {
          properties['Number of Colors'] = String(S.numColors);
        }
        if (S.notes.trim()) properties['Customization Notes'] = S.notes.trim();

        /* Abbreviated design state for print team */
        var designSummary = {
          front: DS.front.elements.map(function (e) {
            return e.type === 'image' ? { type:'image', url:e.url, x:e.x, y:e.y, scale:e.scale }
                                       : { type:'text', content:e.content, font:e.font, size:e.size, color:e.color, x:e.x, y:e.y };
          }),
          back: DS.back.elements.map(function (e) {
            return e.type === 'image' ? { type:'image', url:e.url, x:e.x, y:e.y, scale:e.scale }
                                       : { type:'text', content:e.content, font:e.font, size:e.size, color:e.color, x:e.x, y:e.y };
          }),
        };
        properties['_design_elements'] = JSON.stringify(designSummary).slice(0, 5000);

        var body = { id: variantId, quantity: S.quantity, properties: properties };
        console.log('[cxe] addToCart payload:', JSON.stringify(body).slice(0, 400));

        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
          body:    JSON.stringify(body),
        });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json()
            .catch(function () { throw new Error('Server error (' + r.status + ')'); })
            .then(function (j) { throw new Error(j.description || j.message || 'Could not add to cart.'); });
        }
        return r.json();
      })
      .then(function () {
        setAtcLoading(false);
        [atcBtn, mobileAtcBtn].forEach(function (b) {
          if (!b) return; b.classList.add('is-success'); b.textContent = 'Added! ✓'; b.disabled = false;
        });
        setTimeout(function () { window.location.href = '/cart'; }, 1500);
      })
      .catch(function (err) {
        setAtcLoading(false);
        showAtcError((err && err.message) || 'Could not add to cart. Please try again.');
        updateAtcButton();
      });
  }

  /* ── Static listeners ───────────────────────────────────────── */
  /* ── "Need Help?" floating button ──────────────────────────── */
  function initHelpButton() {
    var btn = document.createElement('div');
    btn.id = 'cxe-help-btn';
    btn.className = 'cxe-help-btn';
    btn.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.898.26 1.836.42 2.81.7A2 2 0 0122 14.92z"/>' +
      '</svg>' +
      '<span>Need Help?</span>';
    document.body.appendChild(btn);

    var card = document.createElement('div');
    card.id = 'cxe-help-card';
    card.className = 'cxe-help-card';
    card.innerHTML =
      '<div class="cxe-help-card__header">' +
        '<div class="cxe-help-card__title">Need Design Assistance?</div>' +
        '<button type="button" class="cxe-help-card__close" id="cxe-help-close" aria-label="Close">&#10005;</button>' +
      '</div>' +
      '<p class="cxe-help-card__desc">Our team can help with complex orders, multiple designs, and custom requests.</p>' +
      '<div class="cxe-help-card__contact">' +
        '<a href="tel:+15149923978" class="cxe-help-card__link">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8F60E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.898.26 1.836.42 2.81.7A2 2 0 0122 14.92z"/></svg>' +
          '<span>+1 (514) 992-3978</span>' +
        '</a>' +
        '<div class="cxe-help-card__hours">Mon–Fri 9am–5pm</div>' +
        '<a href="mailto:drpshp.io@gmail.com" class="cxe-help-card__link">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8F60E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></svg>' +
          '<span>drpshp.io@gmail.com</span>' +
        '</a>' +
      '</div>' +
      '<div class="cxe-help-card__divider"></div>' +
      '<p class="cxe-help-card__cb-label">Or request a callback:</p>' +
      '<div class="cxe-help-card__form">' +
        '<input type="text" id="cxe-help-name" class="cxe-help-card__input" placeholder="Your Name" maxlength="100">' +
        '<input type="tel" id="cxe-help-phone" class="cxe-help-card__input" placeholder="Your Phone" maxlength="30">' +
        '<button type="button" class="cxe-help-card__send" id="cxe-help-send">Send Request</button>' +
        '<p class="cxe-help-card__status" id="cxe-help-status" style="display:none"></p>' +
      '</div>';
    document.body.appendChild(card);

    function openCard() {
      card.classList.add('is-open');
      btn.classList.add('is-hidden');
    }
    function closeCard() {
      card.classList.remove('is-open');
      btn.classList.remove('is-hidden');
    }

    btn.addEventListener('click', openCard);
    document.getElementById('cxe-help-close').addEventListener('click', closeCard);
    document.addEventListener('mousedown', function (e) {
      if (card.classList.contains('is-open') && !card.contains(e.target) && e.target !== btn) {
        closeCard();
      }
    });

    document.getElementById('cxe-help-send').addEventListener('click', function () {
      var nameVal  = (document.getElementById('cxe-help-name').value || '').trim();
      var phoneVal = (document.getElementById('cxe-help-phone').value || '').trim();
      var statusEl = document.getElementById('cxe-help-status');
      if (!nameVal || !phoneVal) {
        statusEl.textContent = 'Please enter your name and phone number.';
        statusEl.style.color = '#F59E0B';
        statusEl.style.display = '';
        return;
      }
      var sendBtn = document.getElementById('cxe-help-send');
      sendBtn.disabled = true;
      sendBtn.textContent = 'Sending…';
      fetch(MIDDLEWARE_URL + '/quotes/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: nameVal, phone: phoneVal }),
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        statusEl.textContent = 'Request sent! We\'ll call you soon.';
        statusEl.style.color = '#86EFAC';
        statusEl.style.display = '';
        sendBtn.textContent = 'Sent';
      }).catch(function () {
        statusEl.textContent = 'Something went wrong. Please call us directly.';
        statusEl.style.color = '#F59E0B';
        statusEl.style.display = '';
        sendBtn.disabled = false;
        sendBtn.textContent = 'Send Request';
      });
    });
  }

  function attachStaticListeners() {
    if (notesEl) {
      notesEl.addEventListener('input', function () {
        S.notes = notesEl.value;
        if (notesCountEl) notesCountEl.textContent = S.notes.length;
      });
    }
    if (copyrightCk) {
      copyrightCk.addEventListener('change', function () {
        S.copyright = copyrightCk.checked;
        if (copyrightErrEl) copyrightErrEl.hidden = true;
        updateAtcButton();
      });
    }
    if (atcBtn)       atcBtn.addEventListener('click', doAddToCart);
    if (mobileAtcBtn) mobileAtcBtn.addEventListener('click', doAddToCart);
    if (resetBtn)   resetBtn.addEventListener('click', function () { Canvas.resetPosition(); });
    if (zoomInBtn)  zoomInBtn.addEventListener('click', function () { Canvas.zoomIn(); });
    if (zoomOutBtn) zoomOutBtn.addEventListener('click', function () { Canvas.zoomOut(); });

    var undoBtn   = document.getElementById('cxe-undo-btn');
    var redoBtn   = document.getElementById('cxe-redo-btn');
    var guidesBtn = document.getElementById('cxe-guides-btn');
    if (undoBtn)   undoBtn.addEventListener('click', undo);
    if (redoBtn)   redoBtn.addEventListener('click', redo);
    if (guidesBtn) {
      guidesBtn.addEventListener('click', function () {
        showSafetyGuides = !showSafetyGuides;
        guidesBtn.classList.toggle('is-active', showSafetyGuides);
        guidesBtn.textContent = '📐';
        guidesBtn.title = showSafetyGuides ? 'Guides ON — click to hide' : 'Guides OFF — click to show';
        Canvas.draw();
      });
    }
    updateUndoRedoUI();

    /* View toggle */
    if (viewToggleEl) {
      viewToggleEl.addEventListener('click', function (e) {
        var card = e.target.closest('.cxe-view-card');
        if (card) selectSide(card.dataset.side);
      });
    }
  }

  /* ── Product load ───────────────────────────────────────────── */

  /* Parse window.colorImageMap entries injected by main-product.liquid.
     The product page HTML contains lines like:
       window.colorImageMap["Black"] = "https://cdn.shopify.com/...";
     We extract these so the editor uses the same server-side Liquid map
     that the product page uses — the only source that's always correct. */
  function parseColorMapFromHtml(html) {
    var map = {};
    var re = /window\.colorImageMap\[("(?:[^"\\]|\\.)*")\]\s*=\s*("(?:[^"\\]|\\.)*")/g;
    var m;
    while ((m = re.exec(html)) !== null) {
      try {
        var key = JSON.parse(m[1]);
        var val = JSON.parse(m[2]);
        if (key && val && !map[key]) map[key] = val;
      } catch (e) {}
    }
    return map;
  }

  function loadProduct(handle, restoreFromSession) {
    console.log('[cxe] fetching:', handle);
    /* Fetch JSON (variants/images) and product HTML (Liquid colorImageMap) in parallel */
    Promise.all([
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
      fetch('/products/' + encodeURIComponent(handle))
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; }),
    ]).then(function (results) {
        var product         = results[0];
        var injectedColorMap = parseColorMapFromHtml(results[1]);
        console.log('[cxe] loaded:', product.title, '(', product.variants && product.variants.length, 'variants)',
                    '| colorMap from HTML:', Object.keys(injectedColorMap).length, 'colors');

        S.product = product;
        if (titleEl)    titleEl.textContent = product.title || 'Customize';
        if (backLinkEl) backLinkEl.href = '/products/' + product.handle;

        Canvas.init(canvasEl, stageEl);

        var fv = product.variants && product.variants[0];
        var firstProductImage = product.images && typeof product.images[0] === 'string'
          ? product.images[0] : null;
        var baseImg = (fv && fv.featured_image && fv.featured_image.src)
          || (typeof product.featured_image === 'string' ? product.featured_image : null)
          || (product.featured_image && product.featured_image.src)
          || firstProductImage
          || null;
        console.log('[cxe] initial base image:', baseImg ? baseImg.slice(0, 80) : 'NONE — canvas will be blank until color selected');
        if (baseImg) Canvas.setBase('front', baseImg);

        buildLeftRail(product, injectedColorMap);

        if (viewToggleEl) viewToggleEl.hidden = false;

        var params       = new URLSearchParams(window.location.search);
        var urlVariantId = parseInt(params.get('variant'), 10);
        if (urlVariantId && product.variants) {
          var matched = product.variants.find(function (v) { return v.id === urlVariantId; });
          if (matched) {
            S.selectedVariantId = matched.id; S.garmentCents = matched.price;
            var cv = S.colorOptionIdx >= 0 ? getVariantOption(matched, S.colorOptionIdx) : null;
            if (cv) selectColor(cv);
            var sv = S.sizeOptionIdx >= 0 ? getVariantOption(matched, S.sizeOptionIdx) : null;
            if (sv) selectSize(sv, matched.id, matched.price);
          }
        }
        /* Auto-restore autosave when coming from the Continue Designing banner */
        if (restoreFromSession) {
          try {
            var saved = JSON.parse(sessionStorage.getItem('drp_autosave') || 'null');
            if (saved) { loadDesignState(saved); showToast('Design restored!'); }
          } catch (e) {}
        }

        updateAtcButton();
        console.log('[cxe] editor ready');
      })
      .catch(function (err) {
        console.error('[cxe] load failed:', err);
        if (wrapEl)     wrapEl.hidden = true;
        if (notFoundEl) notFoundEl.hidden = false;
      });
  }

  /* ── Product picker ─────────────────────────────────────────── */
  function showProductPicker() {
    if (titleEl) titleEl.textContent = 'Choose a Product';
    leftEl.innerHTML =
      '<div class="cxe-panel"><h3 class="cxe-section-label">Search Products</h3>' +
      '<input id="cxe-search-input" class="cxe-textarea" style="min-height:0;height:40px;padding:8px 12px" placeholder="Type to search…" autocomplete="off">' +
      '<div id="cxe-search-results" style="margin-top:10px;display:flex;flex-direction:column;gap:8px"></div></div>';
    var inp = document.getElementById('cxe-search-input');
    var res = document.getElementById('cxe-search-results');
    var deb;
    if (inp) {
      inp.addEventListener('input', function () {
        clearTimeout(deb);
        var q = inp.value.trim();
        if (q.length < 2) { if (res) res.innerHTML = ''; return; }
        deb = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!res) return;
              if (!products.length) { res.innerHTML = '<p style="color:#6B6B6B;font-size:.8125rem">No products found.</p>'; return; }
              res.innerHTML = products.map(function (p) {
                return '<a href="/pages/customize?handle=' + encodeURIComponent(p.handle) + '" style="display:flex;align-items:center;gap:10px;padding:8px 10px;background:rgba(26,26,26,.8);border:1px solid rgba(107,107,107,.25);border-radius:8px;text-decoration:none;color:#F6F6F1;font-size:.875rem">' +
                  (p.image ? '<img src="' + escHtml(p.image) + '" width="40" height="40" style="border-radius:4px;object-fit:cover">' : '') +
                  '<span>' + escHtml(p.title) + '</span></a>';
              }).join('');
            }).catch(function () {});
        }, 300);
      });
    }
  }

  /* ── Entry point ────────────────────────────────────────────── */
  function init() {
    try {
      console.log('[cxe] init — CustPricing:', !!window.CustPricing, 'POSITIONS:', !!window.CUSTOMIZER_POSITIONS);
      document.body.classList.add('cxe-fullscreen');
      attachStaticListeners();
      initHelpButton();
      var params  = new URLSearchParams(window.location.search);
      var handle  = params.get('handle');
      var restore = params.get('restore') === 'true';
      console.log('[cxe] handle:', handle, '| restore:', restore);
      if (!handle) { showProductPicker(); updateAtcButton(); return; }
      loadProduct(handle, restore);
    } catch (err) {
      console.error('[cxe] FATAL init:', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
